export default {
    "報名會友": "报名会友",
    "選填，綁定後該會友可在 App 查看此報名與報到條碼": "选填，绑定后该会友可在 App 查看此报名与报到条码",
    "尚未指定會友": "尚未指定会友",
    "選擇會友": "选择会友",
    "未綁定會友": "未绑定会友",
    "搜尋名單": "搜寻名单",
    "搜尋範圍: 名字/郵件": "搜寻范围: 名字/邮件",
    "族群名稱": "族群名称",
    "請輸入族群名稱": "请输入族群名称",
    "所屬族群": "所属族群",
    "請選擇所屬族群": "请选择所属族群",
    "關閉": "关闭",
    "確定": "确定",
    "最少需要選擇幾位族群成員": "最少需要选择 %s 位族群成员",
    "最少需要選擇幾位託管人員": "最少需要选择 %s 位托管人员",
    "最多只能選擇幾位託管人員": "最多只能选择 %s 位托管人员",
    "尚未異動項目": "尚未异动项目",
    "成員種類1": "族群成员",
    "成員種類2": "托管人员",
    "可選擇幾個會友": "可选择 <b class=\"cgBase\">%s</b> 个会友",
    "請選擇加入的項目": "请选择加入的项目",
    "加入": "加入",
    "移除": "移除",
    "已選擇幾位族群成員": "已选择 <b class=\"cgBase\">%s</b> 位族群成员",
    "已選擇幾位託管人員": "已选择 <b class=\"cgBase\">%s</b> 位托管人员",
    "相關資訊": "相关资讯",
    "基本": "基本",
    "團報": "团报",
    "表單": "表单",
    "金流": "金流",
    "報名人員": "报名人员",
    "報名時間": "报名时间",
    "重設": "重设",
    "立即更新": "立即更新",
    "聚會開始時間": "聚会开始时间",
    "請選擇開始時間": "请选择开始时间",
    "首次聚會開始時間": "首次聚会开始时间",
    "聚會結束時間": "聚会结束时间",
    "請選擇結束時間": "请选择结束时间",
    "首次聚會結束時間": "首次聚会结束时间",
    "資訊公開時間": "信息公开时间",
    "資訊隱藏時間": "信息隐藏时间",
    "聚會時間": "聚会时间",
    "發送聚會的起始效期": "发送聚会的起始效期",
    "發送聚會的結束效期": "发送聚会的结束效期",
    "聚會僅在「資訊公開時間」至「資訊隱藏時間」之間發送，未在此期間不會發送": "聚会仅在「信息公开时间」至「信息隐藏时间」之间发送，未在此期间不会发送",
    "套用於資訊公開／隱藏日期": "应用于信息公开／隐藏日期",
    "請選擇資訊公開時間": "请选择信息公开时间",
    "請選擇資訊隱藏時間": "请选择信息隐藏时间",
    "請選擇聚會時間": "请选择聚会时间",
    "資訊公開時間不可晚於資訊隱藏時間": "信息公开时间不可晚于信息隐藏时间",
    "系統已經推播完成，無法編輯或刪除": "系统已经推播完成，无法编辑或删除",
    "系統已經正在推播，無法編輯或刪除": "系统已经正在推播，无法编辑或删除",
    "標題": "标题",
    "請輸入標題": "请输入标题",
    "上架時間": "上架时间",
    "下架時間": "下架时间",
    "外部活動連結": "外部活动连结",
    "請輸入外部活動連結": "请输入外部活动连结",
    "Youtube連結": "Youtube连结",
    "請輸入Youtube連結": "请输入Youtube连结",
    "Google雲端MP3": "Google云端MP3",
    "請輸入Google雲端MP3": "请输入Google云端MP3",
    "直播連結": "直播连结",
    "請輸入直播連結": "请输入直播连结",
    "外部網站連結": "外部网站连结",
    "請輸入外部網站連結": "请输入外部网站连结",
    "觀看": "观看",
    "外連": "外连",
    "留言": "留言",
    "推播": "推播",
    "排程": "排程",
    "類型": "类型",
    "置頂": "置顶",
    "封面圖": "封面图",
    "操作": "操作",
    "狀態": "状态",
    "建立時間": "建立时间",
    "建立者": "建立者",
    "編輯者": "编辑者",
    "編輯時間": "编辑时间",
    "管理員啟用成功": "管理员启用成功",
    "管理員停用成功": "管理员停用成功",
    "管理員刪除成功": "管理员删除成功",
    "如果不需要變更密碼，不用填寫": "如果不需要变更密码，不用填写",
    "變更密碼": "变更密码",
    "目前當前密碼": "目前当前密码",
    "請輸入目前當前密碼": "请输入目前当前密码",
    "登入密碼": "登入密码",
    "請輸入登入密碼": "请输入登入密码",
    "確認登入密碼": "确认登入密码",
    "請再次輸入登入密碼進行確認": "请再次输入登入密码进行确认",
    "頭像": "头像",
    "帳號": "帐号",
    "請輸入帳號": "请输入帐号",
    "名字": "名字",
    "請輸入名字": "请输入名字",
    "電子郵件": "电子邮件",
    "請輸入電子郵件": "请输入电子邮件",
    "電話": "电话",
    "請輸入聯絡電話": "请输入联络电话",
    "推播說明文字": "推播说明文字",
    "請輸入推播說明文字": "请输入推播说明文字",
    "地點": "地点",
    "請輸入地點": "请输入地点",
    "請選擇狀態": "请选择状态",
    "服事資訊": "服事资讯",
    "請輸入服事資訊": "请输入服事资讯",
    "報名": "报名",
    "場次": "场次",
    "簽到": "签到",
    "回條": "回条",
    "欄位": "栏位",
    "提醒": "提醒",
    "文章": "文章",
    "圖片": "图片",
    "分享": "分享",
    "封面圖尺寸": "(尺寸为 %sx%s 像素)",
    "指定教會": "指定教会",
    "分類": "分类",

    // ---- 以下由 zhCN.output 自動匯入 (Phase 1, 2026-05-15) ----
    "我的教會": "我的教会",
    "牧養系統": "牧养系统",
    "心靈捕手": "心灵捕手",
    "每日靈糧": "每日灵粮",
    "公吿欄": "公吿栏",
    "公吿內容": "公吿内容",
    "控制面板": "控制面板",
    "會友人數": "会友人数",
    "會友新增": "会友新增",
    "會友刪除": "会友删除",
    "上稿次數": "上稿次数",
    "發送推播": "发送推播",
    "聖經開啟": "圣经开启",
    "收藏次數": "收藏次数",
    "留言次數": "留言次数",
    "分享次數": "分享次数",
    "文章觀看": "文章观看",
    "外連觀看": "外连观看",
    "登入次數": "登入次数",
    "公吿管理": "公吿管理",
    "公吿新增": "公吿新增",
    "管理員帳號管理": "管理员帐号管理",
    "管理員新增": "管理员新增",
    "管理員內容": "管理员内容",
    "教會管理": "教会管理",
    "教會新增": "教会新增",
    "教會內容": "教会内容",
    "會友管理": "会友管理",
    "會友內容": "会友内容",
    "奉獻紀錄": "奉献纪录",
    "奉獻內容": "奉献内容",
    "會友管理-奉獻紀錄": "会友管理 - 奉献纪录",
    "我的教會文章管理": "我的教会文章管理",
    "我的教會文章新增": "我的教会文章新增",
    "我的教會文章內容": "我的教会文章内容",
    "文章複製": "文章复製",
    "文章導入": "文章导入",
    "留言紀錄": "留言纪录",
    "我的教會文章管理-留言紀錄": "我的教会文章管理 - 留言纪录",
    "推播紀錄": "推播纪录",
    "推播新增": "推播新增",
    "推播內容": "推播内容",
    "我的教會文章管理-推播紀錄": "我的教会文章管理 - 推播纪录",
    "每日靈糧文章管理": "每日灵粮文章管理",
    "每日靈糧文章新增": "每日灵粮文章新增",
    "每日靈糧文章內容": "每日灵粮文章内容",
    "每日靈糧文章管理-留言紀錄": "每日灵粮文章管理 - 留言纪录",
    "新增推播": "新增推播",
    "每日靈糧文章管理-推播紀錄": "每日灵粮文章管理 - 推播纪录",
    "心靈捕手文章管理": "心灵捕手文章管理",
    "心靈捕手文章新增": "心灵捕手文章新增",
    "心靈捕手文章內容": "心灵捕手文章内容",
    "心靈捕手文章管理-文章管理": "心灵捕手文章管理 - 文章管理",
    "心靈捕手文章管理-留言紀錄": "心灵捕手文章管理 - 留言纪录",
    "心靈捕手文章管理-推播紀錄": "心灵捕手文章管理 - 推播纪录",
    "心靈捕手分類管理": "心灵捕手分类管理",
    "心靈捕手文章管理-分類管理": "心灵捕手文章管理 - 分类管理",
    "圖庫管理": "图库管理",
    "圖庫清單": "图库清单",
    "圖庫核准": "图库核准",
    "圖庫檢舉": "图库检举",
    "圖庫管理-圖庫清單": "图库管理 - 图库清单",
    "圖庫管理-圖庫核准": "图库管理 - 图库核准",
    "圖庫管理-圖庫檢舉": "图库管理 - 图库检举",
    "推播管理": "推播管理",
    "自動化紀錄": "自动化纪录",
    "紀錄內容": "纪录内容",
    "行事曆管理": "行事曆管理",
    "教會行事曆": "教会行事历",
    "行事曆管理-教會行事曆": "行事历管理 - 教会行事历",
    "複製服事": "复製服事",
    "服事新增": "服事新增",
    "服事內容": "服事内容",
    "服事清單": "服事清单",
    "行事曆管理-服事清單": "行事曆管理 - 服事清单",
    "服事群組": "服事群组",
    "群組新增": "群组新增",
    "群組內容": "群组内容",
    "行事曆管理-服事群組": "行事曆管理 - 服事群组",
    "歷史紀錄": "历史纪录",
    "奉獻管理": "奉献管理",
    "循環管理": "循环管理",
    "循環新增": "循环新增",
    "循環內容": "循环内容",
    "循環紀錄": "循环纪录",
    "教學管理": "教学管理",
    "教學新增": "教学新增",
    "教學內容": "教学内容",
    "問題集管理": "问题集管理",
    "問題群組": "问题群组",
    "問題集新增": "问题集新增",
    "問題集內容": "问题集内容",
    "問題集管理-問題群組": "问题集管理 - 问题群组",
    "問題設置": "问题设置",
    "問題設置新增": "问题设置新增",
    "設置內容": "设置内容",
    "問題集管理-問題設置": "问题集管理 - 问题设置",
    "回覆選項": "回覆选项",
    "回覆選項新增": "回覆选项新增",
    "選項內容": "选项内容",
    "問題集管理-回覆選項": "问题集管理 - 回覆选项",
    "表單紀錄": "表单纪录",
    "問題集管理-表單紀錄": "问题集管理 - 表单纪录",
    "客服管理": "客服管理",
    "紀錄新增": "纪录新增",
    "異動紀錄": "异动纪录",
    "帳號紀錄": "帐号纪录",
    "客服管理-帳號紀錄": "客服管理 - 帐号纪录",
    "意見與建議": "意见与建议",
    "反饋內容": "反馈内容",
    "客服管理-意見與建議": "客服管理 - 意见与建议",
    "請我們喝咖啡": "请我们喝咖啡",
    "贊助內容": "赞助内容",
    "客服管理-請我們喝咖啡": "客服管理 - 请我们喝咖啡",
    "歷程管理": "历程管理",
    "攔截紀錄": "拦截纪录",
    "攔截內容": "拦截内容",
    "歷程管理-攔截紀錄": "历程管理 - 拦截纪录",
    "存取紀錄": "存取纪录",
    "存取內容": "存取内容",
    "歷程管理-存取紀錄": "历程管理 - 存取纪录",
    "授權紀錄": "授权纪录",
    "登入內容": "登入内容",
    "歷程管理-授權紀錄": "历程管理 - 授权纪录",
    "活動管理": "活动管理",
    "活動清單": "活动清单",
    "活動新增": "活动新增",
    "活動內容": "活动内容",
    "後台報名": "后台报名",
    "報名清單": "报名清单",
    "報名內容": "报名内容",
    "活動管理-活動清單": "活动管理 - 活动清单",
    "分類管理": "分类管理",
    "分類新增": "分类新增",
    "分類內容": "分类内容",
    "活動管理-分類管理": "活动管理 - 分类管理",
    "直播管理": "直播管理",
    "直播清單": "直播清单",
    "直播新增": "直播新增",
    "直播內容": "直播内容",
    "聊天室發言": "聊天室发言",
    "私密代禱": "私密代祷",
    "直播管理-直播清單": "直播管理 - 直播清单",
    "直播管理-分類管理": "直播管理 - 分类管理",
    "個人資訊": "个人资讯",
    "新朋友數量": "新朋友数量",
    "已跟進會友": "已跟进会友",
    "未跟進會友": "未跟进会友",
    "不跟進會友": "不跟进会友",
    "族群數量": "族群数量",
    "聚會數量": "聚会数量",
    "新朋友管理": "新朋友管理",
    "新朋友新增": "新朋友新增",
    "新朋友內容": "新朋友内容",
    "進階功能": "进阶功能",
    "會友管理-進階功能": "会友管理 - 进阶功能",
    "聚會紀錄": "聚会纪录",
    "聚會內容": "聚会内容",
    "族群管理": "族群管理",
    "聚會查詢": "聚会查询",
    "牧養跟進": "牧养跟进",
    "服事參與": "服事参与",
    "男女比例": "男女比例",
    "年齡分佈": "年龄分佈",
    "五重執事": "五重执事",
    "教育程度": "教育程度",
    "職業分佈": "职业分佈",
    "婚姻狀況": "婚姻状况",
    "受洗人數": "受洗人数",
    "聚會管理": "聚会管理",
    "聚會清單": "聚会清单",
    "聚會新增": "聚会新增",
    "聚會管理-聚會清單": "聚会管理 - 聚会清单",
    "聚會排程": "聚会排程",
    "排程內容": "排程内容",
    "聚會管理-分類管理": "聚会管理 - 分类管理",
    "參數管理": "参数管理",
    "個人資料": "个人资料",
    "返回管理介面": "返回管理介面",
    "登出系統": "登出系统",
    "雙擊加入": "双击加入",
    "雙擊移除": "双击移除",
    "編輯簽到名單": "编辑签到名单",
    "請選擇移除的項目": "请选择移除的项目",
    "請指定協助使用App簽到本活動的會友": "请指定协助<br/>使用App签到本活动的会友",
    "無法搜尋到您指定條件的會友": "无法搜寻到<br />您指定条件的会友",
    "可選擇X個會友": "可选择 <b class=\"cgBase\">%s</b> 个会友",
    "已選擇X個會友": "已选择 <b class=\"cgBase\">%s</b> 个会友",
    "標籤": "标籤",
    "尚無標籤": "尚无标籤",
    "批次標籤": "批次标籤",
    "關閉批次標籤": "关闭批次标籤",
    "已選取": "已选取",
    "全選": "全选",
    "取消全選": "取消全选",
    "雙擊移除此標籤": "双击移除此标籤",
    "請先選取指定會友並輸入標籤": "请先选取指定会友并输入标籤",
    "輸入標籤後按 Enter": "输入标籤后按 Enter",
    "搜尋範圍名字/郵件/編號": "搜寻范围: 名字/邮件/编号",
    "請選擇標籤": "请选择标籤",
    "即將關閉編輯推播": "即将关闭编辑推播",
    "異動項目將會清除請確認後執行": "<span class=\"text-danger\">异动项目将会清除, 请确认后执行</span>",
    "全部": "全部",
    "未分類": "未分类",
    "管理員名單": "管理员名单",
    "耗用時間": "耗用时间",
    "剩餘時間": "剩馀时间",
    "已經超時": "已经超时",
    "請輸入異常App帳號": "请输入异常App帐号",
    "異常App帳號": "异常App帐号",
    "請輸入正確的電子郵件格式按Enter可新增一筆": "请输入正确的电子邮件格式, 按 Enter 可新增一笔",
    "請輸入正確的電子郵件格式": "请输入正确的电子邮件格式",
    "刪除": "删除",
    "即將刪除指定異常帳號": "即将删除指定异常帐号",
    "加入附件": "加入附件",
    "已經選擇X個附件": "已经选择 <b class=\"text-danger ft-16\">%s</b> 个附件",
    "描述": "描述",
    "附件網址": "附件网址",
    "請輸入描述": "请输入描述",
    "請輸入附件網址": "请输入附件网址",
    "請點擊新增進行加入附件": "请点击新增进行加入附件",
    "請先完善表單": "请先完善表单",
    "請輸入正確的附件網址": "请输入正确的附件网址",
    "即將刪除指定附件": "即将删除指定附件",
    "附件內容": "附件内容",
    "網址": "网址",
    "附件": "附件",
    "建立人員": "建立人员",
    "上一次編輯人": "上一次编辑人",
    "上一次編輯時間": "上一次编辑时间",
    "無法編輯": "无法编辑",
    "非目前狀態或者您不是建立人員不能進行編輯": "非目前状态或者您不是建立人员<br/>不能进行编辑",
    "編輯": "编辑",
    "建立": "建立",
    "需要發佈App": "需要发佈App",
    "作廢": "作废",
    "紀錄已作廢": "纪录已作废",
    "總教會僅有全部與管理員名單": "总教会仅有全部与管理员名单",
    "請選擇族群": "请选择族群",
    "清除": "清除",
    "請至少選擇1個族群": "请至少选择1个族群",
    "模擬登入中": "模拟登入中",
    "帳號名稱": "帐号名称",
    "所在時區": "所在时区",
    "UI版本": "UI版本",
    "服務版本": "服务版本",
    "釋放快取": "释放快取",
    "即將手動釋放快取": "即将手动释放快取",
    "請確認後執行": "请确认后执行",
    "公告欄": "公告栏",
    "您還有X筆公告未讀取": "您还有 <b class=\"ft-14 text-danger\">%s</b> 笔公告未读取",
    "前往公告欄": "前往公告栏",
    "系統由中華愛無界全人關懷協會提供和維護使用教學": "系统由 <a target=\"_new\" href=\"%s\">中华爱无界全人关怀协会</a> 提供和维护 / <a target=\"_new\" href=\"%s\">使用教学</a>",
    "教會邀請碼": "教会邀请码",
    "已開啟": "已开启",
    "未開啟": "未开启",
    "最多只能選擇X個選項還可以選擇X個選項": "最多只能选择 <b class=\"ft-16\">%s</b> 个选项, 还可以选择 <b class=\"ft-16\">%s</b> 个选项",
    "已達到選項上限X個": "已达到选项上限 <b class=\"ft-16\">%s</b> 个",
    "新增自定義": "新增自定义",
    "新增電子郵件": "新增电子邮件",
    "新增自定義最多僅能設定X筆": "新增自定义最多仅能设定 <b class=\"cgBase\">%s</b> 笔",
    "寄送郵件名單最多僅能設定X筆": "寄送邮件名单最多仅能设定 <b class=\"cgBase\">%s</b> 笔",
    "常用選項": "常用选项",
    "自定義選項": "自定义选项",
    "通知方式": "通知方式",
    "活動時間點": "活动时间点",
    "%s 分鐘前": "%s 分钟前",
    "%s 小時前": "%s 小时前",
    "X日前": "%s 日前",
    "X週前": "%s 週前",
    "請指定通知方式": "请指定通知方式",
    "請至少選擇一名收件人": "请至少选择一名收件人",
    "請輸入郵件地址": "请输入邮件地址",
    "郵件格式錯誤": "邮件格式错误",
    "YouTube": "YouTube",
    "JustForYou": "JustForYou",
    "這個選項暫時無法使用": "这个选项暂时无法使用",
    "服事": "服事",
    "單次": "单次",
    "每日": "每日",
    "每週": "每週",
    "每月": "每月",
    "每年": "每年",
    "排程預覽": "排程预览",
    "共計X個排程": "共计 <b class=\"ft-14 text-success\">%s</b> 个排程",
    "#": "#",
    "開始時間": "开始时间",
    "報名開始時間": "报名开始时间",
    "複製此活動來新增": "复制此活动来新增",
    "即將複製活動": "即将复制活动",
    "活動複製成功": "活动复制成功",
    "代會友報名，開啟後台報名表單": "代会友报名，开启后台报名表单",
    "開啟報到工具，於活動現場掃碼報到": "开启报到工具，于活动现场扫码报到",
    "顯示報名網址的二維碼": "显示报名网址的二维码",
    "下載報名網址的二維碼圖檔": "下载报名网址的二维码图档",
    "複製報名網址到剪貼簿": "复制报名网址到剪贴簿",
    "請描述此場次的實際舉辦時間與安排": "请描述此场次的实际举办时间与安排",
    "此描述會顯示給報名者，請寫明實際舉辦的日期與時間": "此描述会显示给报名者，请写明实际举办的日期与时间",
    "報名結束時間": "报名结束时间",
    "請選擇報名開始時間": "请选择报名开始时间",
    "請選擇報名結束時間": "请选择报名结束时间",
    "報名結束時間必須大於報名開始時間": "报名结束时间必须大于报名开始时间",
    "僅能在此區間內開放報名活動實際舉辦時間請寫在活動說明中": "仅能在此区间内开放报名；活动实际举办时间请写在活动说明中",
    "優惠時段必須落在報名期間內": "优惠时段必须落在报名期间内",
    "優惠時段不得重疊": "优惠时段不得重叠",
    "結束時間": "结束时间",
    "首次起始日為星期%s, 不能取消": "首次起始日为星期%s, 不能取消",
    "目前最長可定義X年週期請妥善利用資源": "目前最长可定义 %s 年週期, 请妥善利用资源",
    "如果範圍中的月份沒有第X天則會自動跳過": "如果范围中的月份没有第 <b class=\"text-success\">%s</b> 天, 则会自动跳过",
    "方式": "方式",
    "時長": "时长",
    "總計次數": "总计次数",
    "在第 %s 天重複": "在第 %s 天重复",
    "在最後一天重複": "在最后一天重复",
    "在第X週的X": "在第%s週的%s",
    "在最後一個X重複": "在最后一个%s重复",
    "選取希望重複的日期": "选取希望重复的日期",
    "在 %s 的第 %s 天重複": "在 %s 的第 %s 天重复",
    "在X的最後一天重複": "在 %s 的最后一天重复",
    "在X的第X週的X重複": "在 %s 的第%s週的%s重复",
    "在X的最後一個X重複": "在 %s 的最后一个%s重复",
    "選取希望在 %s 號重複的月份": "选取希望在 %s 号重复的月份",
    "請指定至少一天": "请指定至少一天",
    "請指定選項": "请指定选项",
    "請指定需要重複的日期": "请指定需要重复的日期",
    "請指定需要重複的月份": "请指定需要重复的月份",
    "請指定時長": "请指定时长",
    "授權成功": "授权成功",
    "正在準備完成": "正在准备完成",
    "驗證成功": "验证成功",
    "請在App中進行確認": "请在App中进行确认",
    "二維碼超時": "二维码超时",
    "重新產生二維碼": "重新产生二维码",
    "請使用App掃描確認或切換至": "请使用App扫描确认或切换至",
    "輸入登入密碼": "输入登入密码",
    "請輸入登入密碼或切換至": "请输入登入密码或切换至",
    "App掃描確認": "App扫描确认",
    "請使用XApp掃碼登入": "请使用%sApp扫码登入",
    "前往下載XApp": "前往下载%sApp",
    "請使用XApp掃碼進行綁定": "请使用%sApp扫码进行绑定",
    "全部 %s 筆公告": "全部 %s 笔公告",
    "未讀取X筆公告": "未读取 %s 笔公告",
    "請輸入標題關鍵字查詢": "请输入标题关键字查询",
    "X・X・共計X次閱讀": "%s・%s・共计 <b class=\"%s\">%s</b> 次阅读",
    "全部 <b class=\"ft-16 %s\">%s</b> 筆公告": "全部 <b class=\"ft-16 %s\">%s</b> 笔公告",
    "篩選出X筆公告": "筛选出 <b class=\"ft-16 %s\">%s</b> 笔公告",
    "管理員": "管理员",
    "閱讀時間": "阅读时间",
    "暫時還沒有管理員閱讀": "暂时还没有管理员阅读",
    "無法搜尋到您指定條件的管理員": "无法搜寻到<br />您指定条件的管理员",
    "設定教會邀請碼": "设定教会邀请码",
    "請輸入符合規範的邀請碼": "请输入符合规范的邀请码",
    "邀請碼規範6個字元可用數字或英文不可使用符號": "<span class=\"ft-12 text-secondary\">邀请码规范 <b class=\"text-danger ft-14\">6</b> 个字元, 可用数字或英文, 不可使用符号</span>",
    "圖表週期": "图表週期",
    "掃碼成功": "扫码成功",
    "已選擇族群": "已选择族群",
    "雙擊標籤快速移除": "双击标籤快速移除",
    "清空": "清空",
    "即將清空已選擇族群": "即将清空已选择族群",
    "啟用點名選項": "启用点名选项",
    "點名選項可複選": "点名选项可复选",
    "請輸入點名選項名稱": "请输入点名选项名称",
    "新增點名選項": "新增点名选项",
    "啟用": "启用",
    "停用": "停用",
    "已設定X個點名選項": "已设定%s个点名选项",
    "請設定點名選項": "请设定点名选项",
    "請先選擇需要加入的族群": "请先选择需要加入的族群",
    "已經加入該族群": "已经加入该族群",
    "已經設定不跟進該會友": "已经设定不跟进该会友",
    "重新跟進": "重新跟进",
    "該會友尚未加入任何族群": "该会友尚未加入任何族群",
    "移除族群": "移除族群",
    "不跟進": "不跟进",
    "解除族群": "解除族群",
    "復原解除": "復原解除",
    "加入新族群": "加入新族群",
    "族群": "族群",
    "請選擇需要加入的新族群": "请选择需要加入的新族群",
    "請選擇需要加入的族群": "请选择需要加入的族群",
    "即將不跟進該名會友": "即将不跟进该名会友",
    "所有群族將全數解除及取消標註若要再次進入群族被關心請前往不跟進會友重新加入族群請確認後執行請注意儲存後才會生效": "所有群族将<span class=\"text-danger\">全数解除及取消标注</span><br />若要再次进入群族被关心<br />请前往[不跟进会友]重新加入族群, 请确认后执行<br/><span class=\"ft-14 text-warning\">请注意, 储存后才会生效</span>",
    "不跟進會友無法選擇": "不跟进会友无法选择",
    "最上層": "最上层",
    "總教會僅供查看資料無法新增修改": "总教会仅供查看资料, 无法新增修改",
    "族群內容": "族群内容",
    "族群新增": "族群新增",
    "族群編輯": "族群编辑",
    "請至少選擇1位會友作為託管人員": "请至少选择<br />1位会友作为託管人员",
    "請先選擇族群成員再進行託管人員選擇": "请先选择族群成员<br />再进行託管人员选择",
    "族群中沒有會友請先加入會友到族群中": "族群中没有会友<br />请先加入会友到族群中",
    "託管人員": "託管人员",
    "請至少選擇1位託管人員": "请至少选择 <b class=\"ft-14 cgBase\">1</b> 位託管人员",
    "最多能選擇X位託管人員": ", 最多能选择 <b class=\"ft-14 cgBase\">%s</b> 位託管人员",
    "即將關閉族群新增": "即将关闭族群新增",
    "即將關閉族群編輯": "即将关闭族群编辑",
    "即將新增族群": "即将新增族群",
    "即將更新族群內容": "即将更新族群内容",
    "請選擇族群成員": "请选择族群成员",
    "至少需要1位族群成員": "至少需要 <b class=\"ft-20 text-danger\">1</b> 位族群成员",
    "託管人員不足最低限制": "託管人员不足最低限制",
    "至少需要1位託管人員": "至少需要 <b class=\"ft-20 text-danger\">1</b> 位託管人员",
    "託管人員超過最高限制": "託管人员超过最高限制",
    "最多只能選擇X位託管人員": "最多只能选择 <b class=\"ft-20 text-danger\">%s</b> 位託管人员",
    "到": "到",
    "資訊": "资讯",
    "報到": "报到",
    "查看": "查看",
    "本週無聚會": "本週无聚会",
    "自評": "自评",
    "未自評": "未自评",
    "名單中沒有成員": "名单中没有成员",
    "未留言": "未留言",
    "未報到": "未报到",
    "查看此會友資訊": "查看此会友资讯",
    "批次委派成功": "批次委派成功",
    "本次委派批次完成共計X位會友": "本次委派批次完成<br />共计 <b class=\"ft-16 text-success\">%s</b> 位会友",
    "請至少選擇1位會友進行委派": "请至少选择<br />1位会友进行委派",
    "已標註": "已标注",
    "會友匯入成功": "会友汇入成功",
    "本次會友匯入完成共計X位會友": "本次会友汇入完成<br />共计 <b class=\"ft-16 text-success\">%s</b> 位会友",
    "新朋友": "新朋友",
    "請將匯入文件拖至此處": "请将汇入文件拖至此处",
    "或點擊上傳": "或点击上传",
    "只能上傳Excel文件檔案格式為xlsx文件且不超過10MB容量": "只能上传Excel文件(档案格式为xlsx)文件，且不超过<b class=\"text-danger opacity-75\">10MB</b>容量",
    "即將匯出全部會友": "即将汇出全部会友",
    "即將刪除全部會友": "即将删除全部会友",
    "操作無法返回請確認後執行": "操作无法返回, 请确认后执行",
    "請輸入連結文字與網址": "请输入连结文字与网址",
    "插入連結": "插入连结",
    "編輯連結": "编辑连结",
    "釋放連結": "释放连结",
    "前往連結": "前往连结",
    "清空內文": "清空内文",
    "未輸入文字": "<span class=\"a1\">未输入文字</span>",
    "合計約X個文字": "合计约 <b class=\"cgBase\">%s</b> 个文字",
    "連結網址": "连结网址",
    "連結文字": "连结文字",
    "請輸入連結網址": "请输入连结网址",
    "請輸入連結文字": "请输入连结文字",
    "顯示完整圖片": "显示完整图片",
    "文章管理": "文章管理",
    "文章內容": "文章内容",
    "文章新增": "文章新增",
    "已啟用": "已启用",
    "發布於X．X人次瀏覽": "发布于 %s．%s 人次浏览",
    "請輸入文章內容": "请输入文章内容",
    "收藏": "收藏",
    "字級": "字级",
    "前往留言": "前往留言",
    "分享文章由X授權使用": "分享文章由 <b class=\"text-black\">%s</b> 授权使用",
    "圖文": "图文",
    "影音": "影音",
    "音樂": "音乐",
    "MP3": "MP3",
    "直播": "直播",
    "WEB": "WEB",
    "次分類為活動將無法使用直播類型": "次分类为活动, 将无法使用直播类型",
    "編輯標籤": "编辑标籤",
    "送出新增標籤": "送出新增标籤",
    "離開編輯": "离开编辑",
    "無可用標籤": "无可用标籤",
    "開啟選單": "开启选单",
    "關閉選單": "关闭选单",
    "篩選出X個會友": "筛选出 <span class=\"cgBase\">%s</span> 个会友",
    "已選取X個會友": ", 已选取 <span class=\"cgBase\">%s</span> 个会友",
    "請選擇先篩選會友": "请选择先筛选会友",
    "請先選擇標籤": "请先选择标籤",
    "加入請選擇標籤與指定會友": "加入(请选择标籤与指定会友)",
    "移除請選擇標籤與指定會友": "移除(请选择标籤与指定会友)",
    "關鍵字": "关键字",
    "請輸入標籤名稱可用逗號分隔": "请输入标籤名称(可用逗号分隔)",
    "搜尋範圍名字/郵件/會友編號/標籤": "搜寻范围: 名字/邮件/会友编号/标籤",
    "即將批次加入標籤": "即将批次加入标籤",
    "即將批次移除標籤": "即将批次移除标籤",
    "即將移除指定標籤": "即将移除指定标籤",
    "即將移除標籤": "即将移除标籤",
    "上傳": "上传",
    "已選擇X張圖片最多可以上傳X張圖片": "已选择 <b class=\"text-success ft-15\">%s</b> 张图片, 最多可以上传 <b class=\"text-success ft-15\">%s</b> 张图片",
    "已經選完X張圖片": "已经选完 <b class=\"text-danger ft-15\">%s</b> 张图片",
    "圖庫": "图库",
    "請先選擇圖": "请先选择图",
    "歷史圖": "历史图",
    "上傳圖": "上传图",
    "AI生成圖片": "AI 生成图片",
    "生成": "生成",
    "重新生成": "重新生成",
    "換一張": "换一张",
    "使用這張": "使用这张",
    "摘要補充描述": "摘要／补充描述",
    "風格": "风格",
    "攝影": "摄影",
    "水彩": "水彩",
    "扁平插畫": "扁平插画",
    "彩繪玻璃": "彩绘玻璃",
    "古典油畫": "古典油画",
    "信仰主題只以象徵手法呈現不會出現人物": "信仰主题只以象征手法呈现，不会出现人物",
    "生成中已等待X秒": "生成中，已等待 %s 秒",
    "首次生成可能需要2至3分鐘請耐心等候": "首次生成可能需要 2–3 分钟，请耐心等候",
    "此圖為通用畫面並非依文章內容繪製建議換一張": "此图为通用画面，并非依文章内容绘制，建议换一张",
    "生成逾時": "生成超时",
    "網路連線異常請稍後再試": "网络连接异常，请稍后再试",
    "人物": "人物",
    "無人物": "无人物",
    "遠景人物": "远景人物",
    "可能出現遠景或背影人物發佈前請確認": "可能出现远景或背影人物，发布前请确认",
    "人物為主角": "人物为主角",
    "人物會是畫面主角聖經故事仍只畫場景發佈前請確認": "人物会是画面主角（圣经故事仍只画场景），发布前请确认",
    "背影不露臉": "背影（不露脸）",
    "人物只以背影入鏡不會拍到臉": "人物只以背影入镜，不会拍到脸",
    "剪影逆光": "剪影逆光",
    "人物是逆光的深色剪影只有輪廓沒有五官": "人物是逆光的深色剪影，只有轮廓、没有五官",
    "手部特寫": "手部特写",
    "畫面只有手部適合禱告聖餐與服事主題": "画面只有手部，适合祷告、圣餐与服事主题",
    "引擎": "引擎",
    "AI繪圖服務": "AI 绘图服务",
    "QwenImage": "Qwen-Image",
    "額外畫面要求": "额外画面要求",
    "畫面描述": "画面描述",
    "例如畫面中要有一座燈塔色調偏暖": "例如：画面中要有一座灯塔、色调偏暖",
    "此引擎的人物控制屬提示詞層級效果不保證": "（此引擎的人物控制属提示词层级，效果不保证）",
    "寫實攝影": "写实摄影",
    "插畫": "插画",
    "極簡平面": "极简平面",
    "電影感": "电影感",
    "油畫": "油画",
    "水墨畫": "水墨画",
    "鉛筆素描": "铅笔素描",
    "日系動漫": "日系动漫",
    "3D 渲染": "3D 渲染",
    "復古海報": "复古海报",
    "版畫": "版画",
    "剪紙": "剪纸",
    "圖片處理中請稍候": "图片处理中, 请稍候",
    "清除全部": "清除全部",
    "即將取消選擇圖": "即将取消选择图",
    "已經編輯的內容將會重設請確認後執行": "已经编辑的内容将会重设, 请确认后执行",
    "即將清除已經設定的圖": "即将清除已经设定的图",
    "舉報圖片": "举报图片",
    "重設編輯": "重设编辑",
    "上一張": "上一张",
    "沒有上一張了": "没有上一张了",
    "下一張": "下一张",
    "沒有下一張了": "没有下一张了",
    "取消編輯": "取消编辑",
    "編輯文字": "编辑文字",
    "文字大小": "文字大小",
    "文字顏色": "文字颜色",
    "文字位置": "文字位置",
    "上下微調": "上下微调",
    "左右微調": "左右微调",
    "填充文字": "填充文字",
    "垂直微調": "垂直微调",
    "水平微調": "水平微调",
    "請輸入填充文字": "请输入填充文字",
    "請選擇文字大小": "请选择文字大小",
    "請選擇文字顏色": "请选择文字颜色",
    "請選擇文字位置": "请选择文字位置",
    "請選擇垂直微調": "请选择垂直微调",
    "請選擇水平微調": "请选择水平微调",
    "放大": "放大",
    "縮小": "缩小",
    "還原縮放": "还原缩放",
    "下載": "下载",
    "逆時針旋轉": "逆时针旋转",
    "順時針旋轉": "顺时针旋转",
    "名稱": "名称",
    "搜尋不到指定的權限": "搜寻不到指定的权限",
    "僅總教會": "仅总教会",
    "淺色主題": "浅色主题",
    "深色主題": "深色主题",
    "已送達": "已送达",
    "送達時間%04d-%02d-%02d%02d%02d": "送达时间 %04d-%02d-%02d %02d:%02d",
    "已讀取": "已读取",
    "未讀取": "未读取",
    "群體推播無法編輯名單": "群体推播无法编辑名单",
    "編輯推播名單": "编辑推播名单",
    "請至少選擇<br />1位會友進行推播": "请至少选择<br />1位会友进行推播",
    "準備中": "准备中",
    "無法推播": "无法推播",
    "用戶刪除": "用户删除",
    "指定": "指定",
    "全體": "全体",
    "排除機構": "排除机构",
    "選中的機構將會排除並不發送推播訊息": "选中的机构将会排除并不发送推播讯息",
    "將不排除任何機構": "将不排除任何机构",
    "編輯服事群組名單": "编辑服事群组名单",
    "即將關閉編輯服事群組": "即将关闭编辑服事群组",
    "請至少選擇1位會友參與服事群組": "请至少选择<br />1位会友参与服事群组",
    "編輯服事名單": "编辑服事名单",
    "請選擇服事群組": "请选择服事群组",
    "即將關閉編輯服事名單": "即将关闭编辑服事名单",
    "移除整個群組": "移除整个群组",
    "請至少選擇<br />1位會友參與服事": "请至少选择<br />1位会友参与服事",
    "資料複製成功": "资料复製成功",
    "右鍵貼上即可以直接使用": "右键贴上即可以直接使用",
    "檔案下載成功": "档案下载成功",
    "複製內容": "复製内容",
    "顯示密碼": "显示密码",
    "隱藏密碼": "隐藏密码",
    "請先前往建立分類": "请先前往建立分类",
    "請先選擇指定教會": "请先选择指定教会",
    "該教會尚未建立分類": "该教会尚未建立分类",
    "全部教會": "全部教会",
    "未選擇": "未选择",
    "沒有可用的選項": "没有可用的选项",
    "請先選擇所在區域": "请先选择所在区域",
    "請先選擇類型": "请先选择类型",
    "編輯個人標記": "编辑个人标记",
    "標記": "标记",
    "請先選擇需要移除的標記": "请先选择需要移除的标记",
    "已經選取X個標記": "已经选取 <b class=\"cgBase\">%s</b> 个标记",
    "即將刪除指定個人標記": "即将删除指定个人标记",
    "刪除後無法復原請確認後執行": "删除后无法復原, 请确认后执行",
    "共計X名": "共计 %s 名",
    "由系統自動產生": "由系统自动产生",
    "上次編輯人員": "上次编辑人员",
    "內容未經過編輯": "内容未经过编辑",
    "上次編輯時間": "上次编辑时间",
    "循環資訊": "循环资讯",
    "循環代號": "循环代号",
    "提醒代號": "提醒代号",
    "最後循環開始時間": "最后循环开始时间",
    "請先清除表單錯誤": "请先清除表单错误",
    "您沒有建立的權限": "您没有建立的权限",
    "您沒有更新的權限": "您没有更新的权限",
    "總教會僅供查看資料無法更新內容": "总教会仅供查看资料, 无法更新内容",
    "聚會時間已經變動請您留意": "聚会时间已经变动, 请您留意",
    "設定的所有循環均已完成將不會再繼續生成相關單據與提醒": "设定的所有循环均已完成, 将不会再继续生成相关单据与提醒",
    "即將重設內容": "即将重设内容",
    "異動內容將不會保存請確認後執行": "异动内容将不会保存, 请确认后执行",
    "即將返回列表": "即将返回列表",
    "聚會時間已經變動": "聚会时间已经变动",
    "建議您重新檢視循環與提醒設定": "建议您重新检视循环与提醒设定",
    "所屬教會": "所属教会",
    "請選擇所屬教會": "请选择所属教会",
    "請輸入關鍵字": "请输入关键字",
    "同時搜尋名字/郵件/會友編號": "同时搜寻名字/邮件/会友编号",
    "開始時間起": "开始时间(起)",
    "請選擇開始時間起": "请选择开始时间(起)",
    "開始時間迄": "开始时间(迄)",
    "請選擇開始時間迄": "请选择开始时间(迄)",
    "結束時間起": "结束时间(起)",
    "請選擇結束時間起": "请选择结束时间(起)",
    "結束時間迄": "结束时间(迄)",
    "請選擇結束時間迄": "请选择结束时间(迄)",
    "建立時間起": "建立时间(起)",
    "請選擇建立時間起": "请选择建立时间(起)",
    "建立時間迄": "建立时间(迄)",
    "請選擇建立時間迄": "请选择建立时间(迄)",
    "≥指定時間": "(≥)指定时间",
    "≤指定時間": "(≤)指定时间",
    "新增": "新增",
    "無新增權限": "无新增权限",
    "移動至頂部": "移动至顶部",
    "移動至左方": "移动至左方",
    "移動至右方": "移动至右方",
    "搜尋": "搜寻",
    "統計": "统计",
    "多選": "多选",
    "刷新": "刷新",
    "讀取中": "读取中",
    "匯出": "汇出",
    "無匯出權限": "无汇出权限",
    "每頁X筆資料": "每页 <b>%s</b> 笔资料",
    "目前於第X頁共X頁全部X筆資料": "目前于 第 <b class=\"text-justforyou-base ft-16\">%s</b> 页 共 <b class=\"text-justforyou-base ft-16\">%s</b> 页 全部 <b class=\"text-justforyou-base ft-16\">%s</b> 笔资料",
    "列表僅供讀取": "列表仅供读取",
    "找不到指定的資料": "找不到指定的资料",
    "主動": "主动",
    "由總教會發起的主動推播": "由总教会发起的主动推播",
    "循環": "循环",
    "已設定X筆提醒": "已设定%s笔提醒",
    "未設定提醒": "未设定提醒",
    "無查看權限": "无查看权限",
    "無編輯權限": "无编辑权限",
    "更多": "更多",
    "複製": "复製",
    "檢視": "检视",
    "已載入X筆數據共X筆數據": "已载入 <b class=\"text-justforyou-base ft-16\">%s</b> 笔数据 共 <b class=\"text-justforyou-base ft-16\">%s</b> 笔数据",
    "載入完成": "载入完成",
    "收件人": "收件人",
    "可選X名會友": "可选 <b class=\"ft-15 text-base\">%s</b> 名会友",
    "已選X名會友": "已选 <b class=\"ft-15 text-base\">%s</b> 名会友",
    "可選X名會友篩選出X名會友": "可选 <b class=\"ft-15 text-base\">%s</b> 名会友, 筛选出 <b class=\"ft-15 text-base\">%s</b> 名会友",
    "已選X名會友篩選出X名會友": "已选 <b class=\"ft-15 text-base\">%s</b> 名会友, 筛选出 <b class=\"ft-15 text-base\">%s</b> 名会友",
    "此設定不會發送任何通知": "此设置不会发送任何通知",
    "已啟用的提醒時間點都已經過去，或服事開始時間已到，儲存後不會產生任何通知。仍要繼續嗎？": "已启用的提醒时间点都已经过去，或服事开始时间已到，保存后不会产生任何通知。仍要继续吗？",
    "已啟用的提醒時間點都已經過去，或服事開始時間已到。請調整開始時間或改選較晚的提醒。": "已启用的提醒时间点都已经过去，或服事开始时间已到。请调整开始时间或改选较晚的提醒。",
    "已複製「%s」的內容與名單，請重新設定開始與結束時間": "已复制「%s」的内容与名单，请重新设置开始与结束时间",
    "已複製「%s」的內容與收件人，請重新設定排程時間": "已复制「%s」的内容与收件人，请重新设置排程时间",
    "已複製「%s」的全部設定與名單，請確認聚會時間與循環設定後再儲存": "已复制「%s」的全部设置与名单，请确认聚会时间与循环设置后再保存",
    "即將退出選擇編輯": "即将退出选择编辑",
    "合計X次循環排程": "合计 <b class=\"ft-16 text-base\">%s</b> 次循环排程",
    "每": "每",
    "日": "日",
    "週": "週",
    "個月": "个月",
    "年": "年",
    "永遠": "永远",
    "直到": "直到",
    "重複": "重复",
    "次": "次",
    "首次起始日<br/>為星期%s不能取消": "首次起始日<br/>为星期%s不能取消",
    "在第%s天重複": "在第%s天重复",
    "在 %s 的第%s天重複": "在 %s 的第%s天重复",
    "在第X週的X重複": "在第%s週的%s重复",
    "選取希望在%s號重複的月份": "选取希望在%s号重复的月份",
    "請選擇重複結束時間": "请选择重复结束时间",
    "請選擇條件": "请选择条件",
    "請選取希望重複的日期": "请选取希望重复的日期",
    "請選取希望重複的月份": "请选取希望重复的月份",
    "新增自定義選項": "新增自定义选项",
    "系統內建提醒無法取消": "系统内建提醒无法取消",
    "已選X個選項": "已选%s个选项",
    "已設定X個電子郵件": "已设定%s个电子邮件",
    "自定義選項最多僅能設定X筆": "自定义选项最多仅能设定 %s 笔",
    "郵件名單最多僅能設定X筆": "邮件名单最多仅能设定 %s 笔",
    "請輸入正確的電子郵件": "请输入正确的电子邮件",
    "標記為*為必填欄位": "标记为 <b class=\"cgRed\">*</b> 为必填栏位",
    "即將清除表單": "即将清除表单",
    "已經填寫的資料將會清除請確認後執行": "<span class=\"text-danger\">已经填写的资料将会清除, 请确认后执行</span>",
    "請選擇指定教會": "请选择指定教会",
    "請謹慎使用指定教會功能": "请谨慎使用指定教会功能",
    "搜尋條件": "搜寻条件",
    "自行維護": "自行维护",
    "委託管理": "委託管理",
    "前往查看": "前往查看",
    "前往編輯": "前往编辑",
    "轉入牧養會友": "转入牧养会友",
    "標記為待轉入": "标记为待转入",
    "標記為不轉入": "标记为不转入",
    "未授權編輯": "未授权编辑",
    "轉交愛無界團隊": "转交爱无界团队",
    "標示已付款": "标示已付款",
    "整合文章無法複製": "整合文章无法复製",
    "留言內容": "留言内容",
    "該群組下仍有X個會友無法刪除": "该群组下仍有 %s 个会友, 无法删除",
    "該分類下仍有X篇文章無法刪除": "该分类下仍有 %s 篇文章, 无法删除",
    "該分類下仍有X場活動無法刪除": "该分类下仍有 %s 场活动, 无法删除",
    "該分類下仍有X場直播無法刪除": "该分类下仍有 %s 场直播, 无法删除",
    "該分類下仍有X個聚會無法刪除": "该分类下仍有 %s 个聚会, 无法删除",
    "刪除前請先停用": "删除前请先停用",
    "模擬登入": "模拟登入",
    "重建模擬": "重建模拟",
    "選取": "选取",
    "最後編輯時間": "最后编辑时间",
    "最後編輯人員": "最后编辑人员",
    "最後存取時間": "最后存取时间",
    "每頁X項資料": "每页 %s 项资料",
    "目前顯示第X頁共X頁全部共X項資料": "目前显示 第 <b class=\"cgBase\">%s</b> 页 共 <b class=\"cgBase\">%s</b> 页 全部共 <b class=\"cgBase\">%s</b> 项资料",
    "最前頁": "最前页",
    "上一頁": "上一页",
    "下一頁": "下一页",
    "最後頁": "最后页",
    "資料讀取中": "资料读取中",
    "抱歉😔": "抱歉...😔",
    "沒有找到指定的資料": "没有找到指定的资料",
    "全部共0項資料": "全部共 <b class=\"cgBase\">0</b> 项资料",
    "正在讀取請稍候": "正在读取...请稍候",
    "目前暫時沒有可用排序的項目": "目前暂时<br />没有可用排序的项目",
    "拖曳進行排序": "拖曳进行排序",
    "系統由中華愛無界全人關懷協會提供和維護/使用教學": "系统由 <a target=\"_new\" href=\"%s\">中华爱无界全人关怀协会</a> <br/> 提供和维护 / <a target=\"_new\" href=\"%s\">使用教学</a>",
    "選項可複選": "选项可复选",
    "請輸入選項名稱": "请输入选项名称",
    "請至少建立1筆選項": "请至少建立1笔选项",
    "回到頂端": "回到顶端",
    "往左翻動": "往左翻动",
    "往右翻動": "往右翻动",
    "翻至編輯": "翻至编辑",
    "第 <b class=\"ft-20 text-danger\">%s</b> 場": "第 <b class=\"ft-20 text-danger\">%s</b> 场",
    "新增場次": "新增场次",
    "請依照升序方式編輯或刪除避免日期設定錯誤": "请依照升序方式编辑或删除, 避免日期设定错误",
    "場次名稱": "场次名称",
    "第 <b class=\"m-l-5 m-r-5 ft-28\">%s</b> 場": "第 <b class=\"m-l-5 m-r-5 ft-28\">%s</b> 场",
    "X至X": "%s 至 %s",
    "請輸入課程名稱": "请输入课程名称",
    "即將刪除場次": "即将删除场次",
    "上移": "上移",
    "下移": "下移",
    "請輸入場次名稱": "请输入场次名称",
    "請輸入X": "请输入%s",
    "是": "是",
    "否": "否",
    "請輸入X的描述": "请输入%s的描述",
    "請選擇X的描述": "请选择%s的描述",
    "請選擇X": "请选择%s",
    "請輸入姓名": "请输入姓名",
    "第X位報名人員": "第 <b class=\"ft-16 text-success\">%s</b> 位报名人员",
    "必填": "必填",
    "電子郵件格式錯誤": "电子邮件格式错误",
    "請至少選擇一個選項": "请至少选择一个选项",
    "請依照順序編輯": "请依照顺序编辑",
    "新增報名優惠": "新增报名优惠",
    "編輯報名優惠": "编辑报名优惠",
    "請依照升序方式編輯或刪除避免日期與優惠價格設定錯誤": "请依照升序方式编辑或删除, 避免日期与优惠价格设定错误",
    "新增團報": "新增团报",
    "最多僅能建立X筆報名優惠": "最多仅能建立 <b class=\"cgBase\">%s</b> 笔报名优惠",
    "優惠價格已經達到最高值無法再繼續設定優惠價格": "优惠价格已经达到最高值, 无法再继续设定优惠价格",
    "若關閉外部報名僅能用App報名並且無法使用團體報名": "若关闭外部报名, 仅能用App报名并且无法使用团体报名",
    "開啟": "开启",
    "需收費": "需收费",
    "免費": "免费",
    "需限制": "需限制",
    "不限制": "不限制",
    "外部報名": "外部报名",
    "人數上限": "人数上限",
    "人數": "人数",
    "費用": "费用",
    "金額": "金额",
    "掃碼報到": "扫码报到",
    "報名方式": "报名方式",
    "個人報名": "个人报名",
    "團體報名": "团体报名",
    "團體最少報名人數": "团体最少报名人数",
    "團體最多報名人數": "团体最多报名人数",
    "優惠內容": "优惠内容",
    "報名優惠": "报名优惠",
    "優惠價格": "优惠价格",
    "描述內容": "描述内容",
    "可以直接編輯": "可以直接编辑",
    "線上支付": "线上支付",
    "未付款": "未付款",
    "已付款": "已付款",
    "包含往前日期": "<span class=\"text-danger\">(包含往前日期)</span>",
    "溫馨提示": "温馨提示",
    "人數上限未達團體報名最低限制X人無法使用團體報名僅能使用個人報名": "人数上限未达团体报名最低限制 <b class=\"text-danger ft-16\">%s</b> 人, 无法使用团体报名, 仅能使用个人报名",
    "備註": "备注",
    "已經設定活動免費無法啟用線上支付功能": "已经设定活动免费, 无法启用线上支付功能",
    "貴教會未開啟線上奉獻功能無法啟用線上支付功能": "贵教会未开启线上奉献功能, 无法启用线上支付功能",
    "當報名費用低於30或超過20000時將無法使用超商代碼繳費方式支付": "当报名费用低于 <b class=\"text-success ft-16\">30</b> 或 超过 <b class=\"text-success ft-16\">20,000</b> 时, 将无法使用 <b class=\"text-success\">超商代码缴费</b> 方式支付",
    "當報名費用低於20或超過40000時將無法使用超商條碼繳費方式支付": "当报名费用低于 <b class=\"text-success ft-16\">20</b> 或 超过 <b class=\"text-success ft-16\">40,000</b> 时, 将无法使用 <b class=\"text-success\">超商条码缴费</b> 方式支付",
    "當報名費用超過49999時將無法使用WebATMATM轉帳方式支付": "当报名费用超过 <b class=\"text-success ft-16\">49,999</b> 时, 将无法使用 <b class=\"text-success\">WebATM</b>, <b class=\"text-success\">ATM转帐</b> 方式支付",
    "WebATMATM轉帳支付方式僅支援台灣銀行與華南銀行之銀行戶頭": "<b class=\"text-success\">WebATM</b>, <b class=\"text-success\">ATM转帐</b> 支付方式, 仅支援 <b class=\"text-success\">台湾银行</b> 与 <b class=\"text-success\">华南银行</b> 之银行户头",
    "以上單位均為新臺幣": "以上单位均为 <b class=\"text-success\">新台币</b>",
    "請輸入人數": "请输入人数",
    "請輸入金額": "请输入金额",
    "請輸入團體最少報名人數": "请输入团体最少报名人数",
    "請輸入團體最多報名人數": "请输入团体最多报名人数",
    "請輸入優惠價格": "请输入优惠价格",
    "請輸入描述內容": "请输入描述内容",
    "即將刪除優惠價格": "即将删除优惠价格",
    "即將清空優惠價格設定": "即将清空优惠价格设定",
    "您已經有設定優惠價格請確認後執行": "您已经有设定优惠价格, 请确认后执行",
    "變更場次": "变更场次",
    "第 <b class=\"ft-22\">%s</b> 場": "第 <b class=\"ft-22\">%s</b> 场",
    "即將變更場次": "即将变更场次",
    "請至少加入一筆報名優惠": "请至少加入一笔报名优惠",
    "請輸入開始時間": "请输入开始时间",
    "請輸入結束時間": "请输入结束时间",
    "請至少選擇一種報名方式": "请至少选择一种报名方式",
    "優惠價格設定異常": "优惠价格设定异常",
    "請輸入最少報名人數": "请输入最少报名人数",
    "低於最少報名人數限制": "低于最少报名人数限制",
    "請輸入最多報名人數": "请输入最多报名人数",
    "高於報名限制人數": "高于报名限制人数",
    "欄位設定": "栏位设定",
    "新增欄位": "新增栏位",
    "新增選項": "新增选项",
    "系統條件無法移除": "系统条件无法移除",
    "請至少新增一筆選項": "请至少新增一笔选项",
    "附加輸入框": "附加输入框",
    "文字區塊": "文字区块",
    "文字": "文字",
    "是否": "是否",
    "複選": "复选",
    "單選": "单选",
    "日期": "日期",
    "姓名": "姓名",
    "選項值": "选项值",
    "顯示": "显示",
    "請輸入顯示名稱": "请输入显示名称",
    "請輸入選項值": "请输入选项值",
    "即將刪除欄位": "即将删除栏位",
    "請至少選擇一個顯示欄位": "请至少选择一个显示栏位",
    "請輸入名稱": "请输入名称",
    "推播至活動建立者": "推播至活动建立者",
    "遞交報名後提醒的傳達方式": "递交报名后提醒的传达方式",
    "推播通知": "推播通知",
    "需要早於直撥開始時間": "需要早于直拨开始时间",
    "需要早於活動開始時間": "需要早于活动开始时间",
    "將自動同步直撥標題": "将自动同步直拨标题",
    "將自動同步文章標題": "将自动同步文章标题",
    "複製直播描述": "复製直播描述",
    "前往設定分享描述": "前往设定分享描述",
    "整合": "整合",
    "種類": "种类",
    "主分類": "主分类",
    "次分類": "次分类",
    "轉發分享": "转发分享",
    "內容": "内容",
    "請選擇主分類": "请选择主分类",
    "請選擇次分類": "请选择次分类",
    "請選擇上架時間": "请选择上架时间",
    "請選擇下架時間": "请选择下架时间",
    "請選擇轉發分享": "请选择转发分享",
    "請輸入內容": "请输入内容",
    "上架時間需要小於直播開始時間": "上架时间需要小于直播开始时间",
    "下架時間必須大於上架時間": "下架时间必须大于上架时间",
    "請選擇種類": "请选择种类",
    "領袖的好幫手會友的好工具": "领袖的好帮手, 会友的好工具",
    "一個專屬教會的APP是教會的媒體與資訊發佈工具": "一个专属教会的APP, 是教会的媒体与资讯发佈工具",
    "教會訊息活動不漏接隨時隨地跟著讀經禱告": "教会讯息、活动不漏接, 随时随地跟着读经、祷告",
    "Apple用戶端": "Apple用户端",
    "Android用戶端": "Android用户端",
    "系統安全性增強請求": "系统安全性增强请求",
    "請使用App上的掃描功能進行管理員綁定": "请使用App上的扫描功能, 进行管理员绑定",
    "如未綁定將暫時無法使用管理功能": "如未绑定将暂时无法使用管理功能",
    "尚未完成App綁定": "尚未完成App绑定",
    "綁定後開啟App掃碼就能登入更快也更安全": "绑定后, 开启App扫码就能登入, 更快也更安全",
    "免輸入帳號密碼掃碼即可登入": "免输入帐号密码, 扫码即可登入",
    "未綁定不影響現有的帳號密碼登入": "未绑定不影响现有的帐号密码登入",
    "隨時可從右上角頭像選單的個人資料完成綁定": "随时可从右上角头像选单的「个人资料」完成绑定",
    "不再顯示此提示": "不再显示此提示",
    "綁定後可使用App掃碼登入未綁定不影響帳號密碼登入": "绑定后可使用App扫码登入, 未绑定不影响帐号密码登入",
    "您的帳號已完成App綁定可使用App掃碼登入": "您的帐号已完成App绑定, 可使用App扫码登入",
    "綁定App登入": "绑定App登入",
    "綁定狀態": "绑定状态",
    "已綁定": "已绑定",
    "尚未綁定": "尚未绑定",
    "App綁定": "App绑定",
    "綁定會友": "绑定会友",
    "App帳號": "App帐号",
    "解除綁定": "解除绑定",
    "解除後可重新綁定其他App帳號": "解除后可重新绑定其他App帐号",
    "確定解除App綁定": "确定解除App绑定？",
    "解除後將無法再用目前的App帳號掃碼登入之後可以重新綁定其他App帳號": "解除后将无法再用目前的App帐号扫码登入, 之后可以重新绑定其他App帐号 (不影响帐号密码登入)",
    "已解除App綁定": "已解除App绑定",
    "前往綁定": "前往绑定",
    "稍後再說": "稍后再说",
    "APP管理系統": "APP管理系统",
    "掃碼登入": "扫码登入",
    "帳密登入": "帐密登入",
    "忘記密碼": "忘记密码",
    "登入帳號": "登入帐号",
    "驗證碼": "验证码",
    "請輸入登入帳號": "请输入登入帐号",
    "請輸入圖形中的文字": "请输入图形中的文字",
    "暫時無法使用": "暂时无法使用",
    "請稍後再試或請聯絡管理人員": "请稍后再试或请联络管理人员",
    "驗證碼應為6個字元": "验证码应为6个字元",
    "驗證碼錯誤": "验证码错误",
    "重設登入密碼": "重设登入密码",
    "返回登入": "返回登入",
    "本次重設密碼令牌將在X秒後失效": "本次重设密码令牌将在 <b class=\"ft-14 text-danger\">%s</b> 秒后失效",
    "本次重設密碼令牌已經失效": "本次重设密码令牌已经失效",
    "新密碼": "新密码",
    "確認新密碼": "确认新密码",
    "請輸入新密碼": "请输入新密码",
    "請再輸入一次新密碼進行確認": "请再输入一次新密码进行确认",
    "密碼重設成功": "密码重设成功",
    "請使用您設定的新密碼登入": "请使用您设定的新密码登入",
    "是否確定放棄重設密碼": "是否确定放弃重设密码",
    "確認後將返回登入頁面": "确认后将返回登入页面",
    "新密碼強度不足": "新密码强度不足",
    "請再輸入新密碼進行確認": "请再输入新密码进行确认",
    "新密碼確認失敗": "新密码确认失败",
    "兩次密碼輸入不一致": "两次密码输入不一致",
    "重設密碼令牌已失效": "重设密码令牌已失效",
    "請重新進行忘記密碼程序": "请重新进行忘记密码程序",
    "確認郵件驗證碼": "确认邮件验证码",
    "請輸入電子郵件中的6位數字驗證碼": "请输入电子邮件中的 6 位数字验证码",
    "驗證碼空白": "验证码空白",
    "請輸入您的驗證碼": "请输入您的验证码",
    "驗證碼長度異常": "验证码长度异常",
    "驗證碼長度應為6個數字": "验证码长度应为 <b class=\"ft-18 text-danger\">6</b> 个数字",
    "請確認您的驗證碼": "请确认您的验证码",
    "請輸入管理員帳號": "请输入管理员帐号",
    "請輸入管理員電子郵件": "请输入管理员电子邮件",
    "帳號長度不符合規則": "帐号长度不符合规则",
    "至少需要X個字元": "至少需要 <b class=\"ft-20 text-danger\">%s</b> 个字元",
    "找不到指定的管理員": "找不到指定的管理员",
    "未讀": "未读",
    "暫時沒有任何公告": "暂时没有任何公告",
    "找不到指定的公告": "找不到指定的公告",
    "X・共計X次閱讀": "%s・共计 <b class=\"%s\">%s</b> 次阅读",
    "未置頂": "未置顶",
    "新增公吿": "新增公吿",
    "即將啟用公告": "即将启用公告",
    "即將停用公告": "即将停用公告",
    "安全性二級驗證": "安全性二级验证",
    "即將刪除公告請確認後執行": "<span class=\"cgRed\">即将删除公告, 请确认后执行</span>",
    "請輸入您目前的登入密碼": "请输入您目前的登入密码",
    "請選擇是否置頂": "请选择是否置顶",
    "即將新增公吿": "即将新增公吿",
    "閱讀": "阅读",
    "搜尋範圍名字/郵件/會友編號": "搜寻范围: 名字/邮件/会友编号",
    "即將更新公告內容": "即将更新公告内容",
    "最後更新時間": "最后更新时间",
    "預設區間": "预设区间",
    "正在計算統計數據": "正在计算统计数据...",
    "新增管理員": "新增管理员",
    "未輸入": "未输入",
    "即將啟用管理員": "即将启用管理员",
    "即將停用管理員": "即将停用管理员",
    "即將刪除管理員請確認後執行": "<span class=\"cgRed\">即将删除管理员, 请确认后执行</span>",
    "權限": "权限",
    "設置密碼": "设置密码",
    "聯絡電話": "联络电话",
    "請輸入關鍵字或權限代號進行權限名稱搜尋": "请输入关键字或权限代号, 进行权限名称搜寻",
    "即將新增管理員": "即将新增管理员",
    "帳號已經使用": "帐号已经使用",
    "請更換一個帳號": "请更换一个帐号",
    "登入密碼強度不足": "登入密码强度不足",
    "請再輸入登入密碼進行確認": "请再输入登入密码进行确认",
    "密碼確認失敗": "密码确认失败",
    "如果不需要變更密碼不用填寫": "如果不需要变更密码, 不用填写",
    "系統帳號不得變更權限": "系统帐号, 不得变更权限",
    "請注意這名管理員已經停用": "请注意, 这名管理员已经停用",
    "即將更新管理員內容": "即将更新管理员内容",
    "您即將移除您編輯管理員權限的功能移除後你將無法編輯管理員請確認後執行": "<span class=\"text-danger ft18\">您即将移除您编辑管理员权限的功能<br />移除后你将无法编辑管理员, 请确认后执行</span>",
    "請輸入當前密碼": "请输入当前密码",
    "當前密碼錯誤": "当前密码错误",
    "即將返回首頁": "即将返回首页",
    "您已經自行移除管理員管理員權限": "您已经自行移除管理员管理员权限",
    "檔案匯出_教會管理": "档案汇出_教会管理",
    "新增教會": "新增教会",
    "建立日期起": "建立日期(起)",
    "建立日期迄": "建立日期(迄)",
    "主圖": "主图",
    "編號": "编号",
    "心靈捕手狀態": "心灵捕手状态",
    "每日靈糧狀態": "每日灵粮状态",
    "請選擇建立日期起": "请选择建立日期(起)",
    "請選擇建立日期迄": "请选择建立日期(迄)",
    "請輸入編號": "请输入编号",
    "請選擇心靈捕手狀態": "请选择心灵捕手状态",
    "請選擇每日靈糧狀態": "请选择每日灵粮状态",
    "即將啟用教會": "即将启用教会",
    "即將停用教會": "即将停用教会",
    "即將進行教會匯出請確認後執行": "<span class=\"cgRed\">即将进行教会汇出, 请确认后执行</span>",
    "聯絡人": "联络人",
    "奉獻": "奉献",
    "模組": "模组",
    "所在地區": "所在地区",
    "所在城市": "所在城市",
    "地址": "地址",
    "機構": "机构",
    "控制項": "控制项",
    "我的教會標題名稱": "我的教会标题名称",
    "尺寸為XxX像素": "(尺寸为 %sx%s 像素)",
    "標題圖": "标题图",
    "系統模式": "系统模式",
    "每日靈糧標題名稱": "每日灵粮标题名称",
    "心靈捕手標題名稱": "心灵捕手标题名称",
    "查詢長度": "查询长度",
    "奉獻方式": "奉献方式",
    "藍新金流MerchantID": "蓝新金流Merchant ID",
    "藍新金流HashKEY": "蓝新金流Hash KEY",
    "藍新金流HashIV": "蓝新金流Hash IV",
    "奉獻連結文字": "奉献连结文字",
    "奉獻連結": "奉献连结",
    "奉獻描述內容": "奉献描述内容",
    "其他設定": "其他设定",
    "App首頁最新消息筆數": "App首页最新消息笔数",
    "查詢區間": "查询区间",
    "邀請碼模式": "邀请码模式",
    "請選擇所在地區": "请选择所在地区",
    "請選擇所在城市": "请选择所在城市",
    "請輸入地址": "请输入地址",
    "請選擇時區": "请选择时区",
    "請選擇機構": "请选择机构",
    "請輸入我的教會標題名稱": "请输入我的教会标题名称",
    "請輸入每日靈糧標題名稱": "请输入每日灵粮标题名称",
    "請輸入心靈捕手標題名稱": "请输入心灵捕手标题名称",
    "請選擇查詢長度": "请选择查询长度",
    "請輸入藍新金流MerchantID": "请输入蓝新金流Merchant ID",
    "請輸入藍新金流HashKEY": "请输入蓝新金流Hash KEY",
    "請輸入藍新金流HashIV": "请输入蓝新金流Hash IV",
    "請輸入奉獻連結文字": "请输入奉献连结文字",
    "請輸入奉獻連結": "请输入奉献连结",
    "請輸入奉獻描述內容": "请输入奉献描述内容",
    "請選擇App首頁最新消息筆數": "请选择App首页最新消息笔数",
    "請選擇查詢區間": "请选择查询区间",
    "即將新增教會": "即将新增教会",
    "異常發生": "异常发生",
    "無法停用目前登入的教會": "无法停用目前登入的教会",
    "請選擇所在區域": "请选择所在区域",
    "請選擇所在時區": "请选择所在时区",
    "請選擇心靈捕手系統模式": "请选择心灵捕手系统模式",
    "請選擇每日靈糧系統模式": "请选择每日灵粮系统模式",
    "編號已經存在": "编号已经存在",
    "請選擇邀請碼模式": "请选择邀请码模式",
    "請輸入主要聯絡人姓名": "请输入主要联络人姓名",
    "請輸入主要聯絡人聯絡電話": "请输入主要联络人联络电话",
    "請輸入主要聯絡人電子郵件": "请输入主要联络人电子邮件",
    "主要聯絡人電子郵件格式錯誤": "主要联络人电子邮件格式错误",
    "次要聯絡人電子郵件格式錯誤": "次要联络人电子邮件格式错误",
    "請選擇奉獻系統模式": "请选择奉献系统模式",
    "請注意這間教會已經停用": "请注意, 这间教会已经停用",
    "簡介標題": "简介标题",
    "簡介內容": "简介内容",
    "請輸入簡介標題": "请输入简介标题",
    "請輸入簡介內容": "请输入简介内容",
    "即將清除教會邀請碼": "即将清除教会邀请码",
    "清除後儲存將無法使用教會邀請碼功能請確認後執行": "<span class=\"text-danger\">清除后储存, 将无法使用教会邀请码功能<br />请确认后执行</span>",
    "即將更新教會內容": "即将更新教会内容",
    "請先選取指定會友": "请先选取指定会友",
    "附加標籤到指定會友": "附加标籤到指定会友",
    "清除並附加標籤到指定會友": "清除并附加标籤到指定会友",
    "刪除指定會友的標籤": "删除指定会友的标籤",
    "重設已輸入標籤值": "重设已输入标籤值",
    "檔案匯出_會友管理": "档案汇出_会友管理",
    "新增會友": "新增会友",
    "開啟編輯標籤": "开启编辑标籤",
    "關閉編輯標籤": "关闭编辑标籤",
    "委身編號": "委身编号",
    "未填寫": "未填写",
    "請輸入標籤可用逗號分隔連續輸入並按enter輸入": "请输入标籤,可用逗号分隔连续输入并按enter输入",
    "即將啟用會友": "即将启用会友",
    "即將停用會友": "即将停用会友",
    "即將對指定的會友加入標籤": "即将对指定的会友加入标籤",
    "即將對指定的會友取代標籤": "即将对指定的会友取代标籤",
    "即將對指定的會友移除標籤": "即将对指定的会友移除标籤",
    "即將進行會友匯出請確認後執行": "<span class=\"cgRed\">即将进行会友汇出, 请确认后执行</span>",
    "即將進行全部會友刪除請確認後執行": "<span class=\"cgRed\">即将进行全部会友删除, 请确认后执行</span>",
    "請注意這名會友已經停用": "请注意, 这名会友已经停用",
    "統計資訊": "统计资讯",
    "文章回覆": "文章回覆",
    "所屬教會名稱": "所属教会名称",
    "所屬教會ID": "所属教会ID",
    "稱謂": "称谓",
    "生日": "生日",
    "聯絡地址": "联络地址",
    "職業": "职业",
    "受洗時間": "受洗时间",
    "刪除時間": "删除时间",
    "未輸入稱謂": "未输入称谓",
    "未輸入生日": "未输入生日",
    "未輸入聯絡電話": "未输入联络电话",
    "未輸入所在地區": "未输入所在地区",
    "未輸入所在城市": "未输入所在城市",
    "未輸入聯絡地址": "未输入联络地址",
    "未輸入職業": "未输入职业",
    "未輸入受洗時間": "未输入受洗时间",
    "請輸入委身編號": "请输入委身编号",
    "即將更新會友內容": "即将更新会友内容",
    "新增循環": "新增循环",
    "週期": "週期",
    "即將啟用循環": "即将启用循环",
    "即將停用循環": "即将停用循环",
    "建立後類型與目標無法修改請確認": "建立后类型与目标无法修改, 请确认",
    "點擊查看說明": "点击查看说明",
    "部分文章無法設定循環": "部分文章无法设定循环",
    "排程時間": "排程时间",
    "項目": "项目",
    "請選擇類型": "请选择类型",
    "未填寫標題": "未填写标题",
    "未選擇上架時間": "未选择上架时间",
    "未選擇排程時間": "未选择排程时间",
    "未選擇開始時間": "未选择开始时间",
    "未選擇下架時間": "未选择下架时间",
    "未選擇結束時間": "未选择结束时间",
    "請選擇項目": "请选择项目",
    "即將新增循環": "即将新增循环",
    "請注意這筆循環已經停用": "请注意, 这笔循环已经停用",
    "建立後類型與目標無法修改": "建立后类型与目标无法修改",
    "歷程紀錄": "历程纪录",
    "即將更新循環內容": "即将更新循环内容",
    "新增分類": "新增分类",
    "文章數量": "文章数量",
    "排序": "排序",
    "請選擇教會": "请选择教会",
    "即將啟用分類": "即将启用分类",
    "即將停用分類": "即将停用分类",
    "即將刪除分類請確認後執行": "<span class=\"cgRed\">即将删除分类, 请确认后执行</span>",
    "僅能指定自行維護心靈捕手的教會": "仅能指定自行维护心灵捕手的教会",
    "即將新增分類": "即将新增分类",
    "請選擇封面圖": "请选择封面图",
    "請指定教會": "请指定教会",
    "請注意這個分類已經停用": "请注意, 这个分类已经停用",
    "即將更新分類內容": "即将更新分类内容",
    "文章整合": "文章整合",
    "查看留言紀錄": "查看留言纪录",
    "查看推播紀錄": "查看推播纪录",
    "新增文章": "新增文章",
    "分享連結": "分享连结",
    "請選擇置頂": "请选择置顶",
    "請選擇分類": "请选择分类",
    "我的教會x心靈捕手": "我的教会x心灵捕手",
    "請貼上您的分享連結": "<span class=\"text-success\">请贴上您的分享连结</span>",
    "請輸入分享連結": "请输入分享连结",
    "即將文章置頂": "即将文章置顶",
    "即將文章取消置頂": "即将文章取消置顶",
    "即將啟用文章": "即将启用文章",
    "即將停用文章": "即将停用文章",
    "即將刪除文章請確認後執行": "<span class=\"cgRed\">即将删除文章, 请确认后执行</span>",
    "活動": "活动",
    "類型為直播無法使用活動次分類": "类型为直播, 无法使用活动次分类",
    "僅能指定自行維護每日靈糧的教會": "仅能指定自行维护每日灵粮的教会",
    "循環方式": "循环方式",
    "聚會週期": "聚会周期",
    "循環日": "循环日",
    "時間": "时间",
    "文章圖片": "文章图片",
    "分享內文": "分享内文",
    "請選擇循環方式": "请选择循环方式",
    "請選擇循環日": "请选择循环日",
    "請選擇日期": "请选择日期",
    "請選擇時間": "请选择时间",
    "請輸入分享內文": "请输入分享内文",
    "即將清除所有文章圖片": "即将清除所有文章图片",
    "即將新增文章": "即将新增文章",
    "即將複製文章": "即将复製文章",
    "請輸入分享描述": "请输入分享描述",
    "此文章無法複製": "此文章无法复製",
    "已經啟用整合功能": "已经启用整合功能",
    "重計留言數量": "重计留言数量",
    "請先選擇需要刪除的留言": "请先选择需要删除的留言",
    "即將重新計算文章留言數量": "即将重新计算文章留言数量",
    "即將刪除文章留言": "即将删除文章留言",
    "請注意這篇文章已經停用": "请注意, 这篇文章已经停用",
    "已啟用直播文章整合無法編輯": "已启用直播文章整合, 无法编辑",
    "已啟用活動文章整合無法編輯": "已启用活动文章整合, 无法编辑",
    "心靈捕手外部文章整合無法編輯": "心灵捕手外部文章整合, 无法编辑",
    "前往修改": "前往修改",
    "觀看次數": "观看次数",
    "所屬教會編號": "所属教会编号",
    "即將更新文章內容": "即将更新文章内容",
    "此分類下找不到圖片": "此分类下找不到图片",
    "請先選擇需要處理的圖片": "请先选择需要处理的图片",
    "全部X張圖片": "全部 <b class=\"ft-16 cgBase\">%s</b> 张图片",
    "即將重新整理": "即将重新整理",
    "已選擇的項目將會重設請確認後執行": "已选择的项目将会重设, 请确认后执行",
    "即將核准指定的圖片": "即将核准指定的图片",
    "即將拒絕指定的圖片": "即将拒绝指定的图片",
    "核實檢舉": "核实检举",
    "撤銷檢舉": "撤销检举",
    "即將核實檢舉指定的圖片": "即将核实检举指定的图片",
    "即將撤銷檢舉指定的圖片": "即将撤销检举指定的图片",
    "請選擇會友進行推播通知": "请选择会友进行推播通知",
    "最多只能選擇X位會友進行推播通知": "最多只能选择%s位会友进行推播通知",
    "請選擇至少X位會友進行推播通知": "请选择至少%s位会友进行推播通知",
    "搜尋不到指定的推播通知會友": "搜寻不到指定的推播通知会友",
    "名單": "名单",
    "類型於建立之後不能變更": "类型于建立之后不能变更",
    "請選擇排程時間": "请选择排程时间",
    "簡述": "简述",
    "請輸入簡述": "请输入简述",
    "推播目前正在排程中": "推播目前正在排程中",
    "目前推播正在進行中無法修改進度X": "目前推播正在进行中无法修改, 进度 %s",
    "推播已經全部完成無法修改": "推播已经全部完成无法修改",
    "即將儲存內容": "即将储存内容",
    "編輯名單": "编辑名单",
    "預覽排程": "预览排程",
    "請選擇排除機構": "请选择排除机构",
    "不能排除所有機構": "不能排除所有机构",
    "排程時間必須大於現在時間": "排程时间必须大于现在时间",
    "請至少選擇1位會友進行推播": "请至少选择1位会友进行推播",
    "讀取": "读取",
    "讀取時間": "读取时间",
    "送達狀態": "送达状态",
    "送達時間": "送达时间",
    "開啟時間": "开启时间",
    "發送分析": "发送分析",
    "發送清單": "发送清单",
    "請選擇讀取": "请选择读取",
    "執行時間": "执行时间",
    "生成時間": "生成时间",
    "識別ID": "识别ID",
    "支援廠商": "支援厂商",
    "APNS": "APNS",
    "FCM": "FCM",
    "未對應": "未对应",
    "已對應": "已对应",
    "推播類型": "推播类型",
    "請選擇推播類型": "请选择推播类型",
    "即將更新內容": "即将更新内容",
    "對象": "对象",
    "指定推播": "指定推播",
    "全體推播": "全体推播",
    "推播數量": "推播数量",
    "進度X": "<br/>进度 %s",
    "排程中": "排程中",
    "發送中": "发送中",
    "已完成": "已完成",
    "請選擇對象": "请选择对象",
    "排程時間起": "排程时间(起)",
    "請選擇排程時間起": "请选择排程时间(起)",
    "排程時間迄": "排程时间(迄)",
    "請選擇排程時間迄": "请选择排程时间(迄)",
    "即將刪除推播通知請確認後執行": "<span class=\"cgRed\">即将删除推播通知, 请确认后执行</span>",
    "排程日期起": "排程日期(起)",
    "排程日期迄": "排程日期(迄)",
    "數量": "数量",
    "進度": "进度",
    "請選擇排程日期起": "请选择排程日期(起)",
    "請選擇排程日期迄": "请选择排程日期(迄)",
    "即將刪除推播請確認後執行": "<span class=\"cgRed\">即将删除推播, 请确认后执行</span>",
    "請注意推播類型建立後將無法變更": "请注意, 推播类型建立后将无法变更",
    "全部會友名單": "全部会友名单",
    "選中的機構將不會發送推播訊息": "选中的机构将不会发送推播讯息",
    "即將新增推播內容": "即将新增推播内容",
    "請至少選擇 <b class=\"ft-24 text-danger\">1</b> 位會友進行推播": "请至少选择 <b class=\"ft-24 text-danger\">1</b> 位会友进行推播",
    "即將更新推播內容": "即将更新推播内容",
    "請先建立服事群組": "请先建立服事群组",
    "選擇會友參與服事": "选择会友参与服事",
    "最多只能選擇X位會友參與服事": "最多只能选择%s位会友参与服事",
    "請選擇至少X位會友參與服事": "请选择至少%s位会友参与服事",
    "參與群組": "参与群组",
    "請選擇參與群組": "请选择参与群组",
    "請選擇會友參與服事": "请选择会友参与服事",
    "搜尋不到指定的參與服事會友": "搜寻不到指定的参与服事会友",
    "結束時間必須大於開始時間": "结束时间必须大于开始时间",
    "請輸入說明": "请输入说明",
    "請至少選擇1位會友參與服事": "请至少选择1位会友参与服事",
    "請完善提醒的參數設定": "请完善提醒的参数设定",
    "請完善循環的參數設定": "请完善循环的参数设定",
    "目前服事處於僅讀取狀態無法更新": "目前服事处于仅读取状态无法更新",
    "目前服事處於停用狀態": "目前服事处于停用状态",
    "參與人數": "参与人数",
    "已停用": "已停用",
    "啟用中": "启用中",
    "即將啟用服事": "即将启用服事",
    "即將停用服事": "即将停用服事",
    "即將刪除服事請確認後執行": "<span class=\"cgRed\">即将删除服事, 请确认后执行</span>",
    "新增群組": "新增群组",
    "即將啟用群組": "即将启用群组",
    "即將停用群組": "即将停用群组",
    "即將刪除群組請確認後執行": "<span class=\"cgRed\">即将删除群组, 请确认后执行</span>",
    "即將新增群組": "即将新增群组",
    "請至少選擇1位人員參與服事": "请至少选择1位人员参与服事",
    "請注意這個群組已經停用": "请注意, 这个群组已经停用",
    "即將更新群組內容": "即将更新群组内容",
    "周內新增": "周内新增",
    "月內新增": "月内新增",
    "離開人數": "离开人数",
    "群組建立": "群组建立",
    "加入群組": "加入群组",
    "從群組中離開": "从群组中离开",
    "新增服事": "新增服事",
    "開始日期起": "开始日期(起)",
    "開始日期迄": "开始日期(迄)",
    "結束日期起": "结束日期(起)",
    "結束日期迄": "结束日期(迄)",
    "請選擇開始日期起": "请选择开始日期(起)",
    "請選擇開始日期迄": "请选择开始日期(迄)",
    "請選擇結束日期起": "请选择结束日期(起)",
    "請選擇結束日期迄": "请选择结束日期(迄)",
    "說明": "说明",
    "其他資訊": "其他资讯",
    "請輸入備註": "请输入备注",
    "請輸入其他資訊": "请输入其他资讯",
    "即將新增服事": "即将新增服事",
    "請注意這個服事已經停用": "请注意, 这个服事已经停用",
    "即將更新服事內容": "即将更新服事内容",
    "奉獻匯出_會友管理": "奉献汇出_会友管理",
    "奉獻日期起": "奉献日期(起)",
    "奉獻日期迄": "奉献日期(迄)",
    "訂單號": "订单号",
    "奉獻金額": "奉献金额",
    "請選擇奉獻日期起": "请选择奉献日期(起)",
    "請選擇奉獻日期迄": "请选择奉献日期(迄)",
    "請輸入訂單號": "请输入订单号",
    "即將進行奉獻匯出請確認後執行": "<span class=\"cgRed\">即将进行奉献汇出, 请确认后执行</span>",
    "回應": "回应",
    "付款時間": "付款时间",
    "會友ID": "会友ID",
    "會友編號": "会友编号",
    "會友姓名": "会友姓名",
    "會友帳號": "会友帐号",
    "結果": "结果",
    "金流狀態": "金流状态",
    "未填寫聯絡電話": "未填写联络电话",
    "新增教學": "新增教学",
    "即將啟用教學": "即将启用教学",
    "即將停用教學": "即将停用教学",
    "即將刪除教學請確認後執行": "<span class=\"cgRed\">即将删除教学, 请确认后执行</span>",
    "請注意這個教學已經停用": "请注意, 这个教学已经停用",
    "來源": "来源",
    "此紀錄為未知來源": "此纪录为未知来源",
    "流水號": "流水号",
    "存取方式": "存取方式",
    "遠端位置": "远端位置",
    "存取路徑": "存取路径",
    "請輸入方式": "请输入方式",
    "請選擇結果": "请选择结果",
    "等級": "等级",
    "結果代碼": "结果代码",
    "攔截": "拦截",
    "請選擇模組": "请选择模组",
    "攔截呼叫": "拦截呼叫",
    "標的教會": "标的教会",
    "標的物件流水號": "标的物件流水号",
    "攔截類": "拦截类",
    "攔截函式": "拦截函式",
    "回滾事務": "回滚事务",
    "副標題": "副标题",
    "提交參數": "提交参数",
    "無標題": "无标题",
    "無副標題": "无副标题",
    "無描述": "无描述",
    "樣本ID": "样本ID",
    "請輸入樣本ID": "请输入样本ID",
    "角色": "角色",
    "請選擇角色": "请选择角色",
    "樣本ID請輸入數字": "样本ID请输入数字",
    "發佈App": "发佈App",
    "請選擇發佈App": "请选择发佈App",
    "即將新增紀錄": "即将新增纪录",
    "即將更新紀錄": "即将更新纪录",
    "同時搜尋標題與描述": "同时搜寻标题与描述",
    "請選擇作廢": "请选择作废",
    "建立人": "建立人",
    "請選擇建立人": "请选择建立人",
    "請選擇上一次編輯人": "请选择上一次编辑人",
    "即將作廢紀錄請確認後執行": "<span class=\"cgRed\">即将作废纪录, 请确认后执行</span>",
    "新增紀錄": "新增纪录",
    "單號": "单号",
    "異常帳號": "异常帐号",
    "超時": "超时",
    "返工": "返工",
    "請輸入角色": "请输入角色",
    "請輸入類型": "请输入类型",
    "請輸入單號": "请输入单号",
    "請選擇超時": "请选择超时",
    "請選擇返工": "请选择返工",
    "管理團隊": "管理团队",
    "層級": "层级",
    "請選擇層級": "请选择层级",
    "即將反饋至愛無界管理團隊": "即将反馈至爱无界管理团队",
    "請認後執行": "请认后执行",
    "請注意這個反饋還未標示已讀取": "请注意, 这个反馈还未标示已读取",
    "即將更新反饋內容": "即将更新反馈内容",
    "即將反饋至愛無界管理團隊請認後執行": "<b class=\"ft-20 text-danger\">即将反馈至爱无界管理团队, 请认后执行</b>",
    "請我們喝咖啡匯出_客服管理": "请我们喝咖啡汇出_客服管理",
    "贊助日期起": "赞助日期(起)",
    "贊助日期迄": "赞助日期(迄)",
    "贊助金額": "赞助金额",
    "請選擇贊助日期起": "请选择赞助日期(起)",
    "請選擇贊助日期迄": "请选择赞助日期(迄)",
    "即將進行請我們喝咖啡匯出請確認後執行": "<span class=\"cgRed\">即将进行请我们喝咖啡汇出, 请确认后执行</span>",
    "請輸入完整的電子郵件": "请输入完整的电子邮件",
    "會友已經停用": "会友已经停用",
    "會友已於X自行刪除": "会友已于 <b>%s</b> 自行删除",
    "教會已經停用": "教会已经停用",
    "教會已經刪除": "教会已经删除",
    "機構已經停用": "机构已经停用",
    "機構已經刪除": "机构已经删除",
    "查詢到X筆紀錄": "查询到 <b class=\"ft-18 text-success\">%s</b> 笔纪录",
    "查詢不到任何結果": "查询不到任何结果",
    "最後10筆推播通知": "最后 <b class=\"text-success ft-18\">10</b> 笔推播通知",
    "依照預定推播時間降冪排序": "(依照预定推播时间降幂排序)",
    "沒有推播通知紀錄": "没有推播通知纪录",
    "推播ID": "推播ID",
    "排定發送時間": "排定发送时间",
    "裝置支援商": "装置支援商",
    "裝置製造商": "装置製造商",
    "裝置型號": "装置型号",
    "裝置操作系統": "装置操作系统",
    "裝置App版本": "装置App版本",
    "登入權杖": "登入权杖",
    "sys_tokentoken": "(sys_token.token)",
    "推播識別碼": "推播识别码",
    "core_admin_client_notificationkey": "(core_admin_client_notification.key)",
    "所屬機構ID": "所属机构ID",
    "所屬機構名稱": "所属机构名称",
    "更新時間": "更新时间",
    "請輸入完整的電子郵件進行查詢": "请输入完整的电子邮件进行查询",
    "直播數量": "直播数量",
    "新增直播": "新增直播",
    "請選擇文章整合": "请选择文章整合",
    "即將啟用直播": "即将启用直播",
    "即將停用直播": "即将停用直播",
    "即將刪除直播請確認後執行": "<span class=\"cgRed\">即将删除直播, 请确认后执行</span>",
    "YouTube網址": "YouTube网址",
    "標籤-大廳": "标籤 - 大厅",
    "標籤-代禱": "标籤 - 代祷",
    "標籤-關於": "标籤 - 关于",
    "歡迎詞-大廳": "欢迎词 - 大厅",
    "歡迎詞-代禱": "欢迎词 - 代祷",
    "回應詞-代禱": "回应词 - 代祷",
    "請輸入YouTube網址": "请输入YouTube网址",
    "請輸入標籤大廳": "请输入标籤(大厅)",
    "請輸入標籤代禱": "请输入标籤(代祷)",
    "請輸入標籤關於": "请输入标籤(关于)",
    "請輸入歡迎詞大廳": "请输入欢迎词(大厅)",
    "請輸入歡迎詞代禱": "请输入欢迎词(代祷)",
    "請輸入回應詞代禱": "请输入回应词(代祷)",
    "即將新增直播": "即将新增直播",
    "請輸入YouTube連結": "请输入YouTube连结",
    "聊天室發言內容": "聊天室发言内容",
    "訪客": "访客",
    "私密代禱內容": "私密代祷内容",
    "您即將查看會友私密個人資訊": "您即将查看会友私密个人资讯",
    "我將妥善與謹慎使用相關資訊": "我将妥善与谨慎使用相关资讯",
    "請注意這個直播已經停用": "请注意, 这个直播已经停用",
    "複製直播網址": "复製直播网址",
    "即將更新直播內容": "即将更新直播内容",
    "活動數量": "活动数量",
    "新增活動": "新增活动",
    "已報名": "已报名",
    "含未付費": "含未付费",
    "即將啟用活動": "即将启用活动",
    "即將停用活動": "即将停用活动",
    "即將刪除活動請確認後執行": "<span class=\"cgRed\">即将删除活动, 请确认后执行</span>",
    "活動建立人員將會自動擁有本活動App簽到功能可不指定其他協助簽到人員": "活动建立人员将会自动拥有本活动App签到功能, 可不指定其他协助签到人员",
    "已經開啟報名優惠功能無法修改日期": "已经开启报名优惠功能, 无法修改日期",
    "活動開始時間": "活动开始时间",
    "活動結束時間": "活动结束时间",
    "請輸入活動開始時間": "请输入活动开始时间",
    "請輸入活動結束時間": "请输入活动结束时间",
    "即將新增活動": "即将新增活动",
    "請輸入回條描述": "请输入回条描述",
    "團體報名人數最少X位最多X位": "团体报名人数最少 <b class=\"ft-16\">%s</b> 位, 最多 <b class=\"ft-16\">%s</b> 位",
    "還需要X位報名": ", 还需要 <b class=\"ft-16\">%s</b> 位报名",
    "最多還可以報名X位": ", 最多还可以报名 <b class=\"ft-16\">%s</b> 位",
    "已經達到活動報名人數上限": ", 已经达到活动报名人数上限",
    "已達到團報最高人數限制": ", 已达到团报最高人数限制",
    "報名總覽": "报名总览",
    "請先增加團體報名人員": "请先增加团体报名人员",
    "合計X位報名": "合计 <b class=\"ft-16 text-success\">%s</b> 位报名",
    "原價": "原价",
    "X之前": "%s 之前",
    "新增團報人員": "新增团报人员",
    "編輯團報人員": "编辑团报人员",
    "活動場次": "活动场次",
    "支付狀態": "支付状态",
    "教會機構名稱": "教会(机构)名称",
    "教會機構所在城市": "教会(机构)所在城市",
    "聯絡人姓名": "联络人姓名",
    "聯絡人電話": "联络人电话",
    "聯絡人電子郵件": "联络人电子邮件",
    "郵遞區號": "邮递区号",
    "通訊地址": "通讯地址",
    "請輸入教會機構名稱": "请输入教会(机构)名称",
    "請輸入教會機構所在城市": "请输入教会(机构)所在城市",
    "請輸入聯絡人姓名": "请输入联络人姓名",
    "請輸入聯絡人電話": "请输入联络人电话",
    "請輸入聯絡人電子郵件": "请输入联络人电子邮件",
    "請輸入郵遞區號": "请输入邮递区号",
    "請輸入通訊地址": "请输入通讯地址",
    "即將儲存後台報名": "即将储存后台报名",
    "請選擇報名方式": "请选择报名方式",
    "指定的報名方式不存在": "指定的报名方式不存在",
    "請選擇活動場次": "请选择活动场次",
    "指定的活動場次不存在": "指定的活动场次不存在",
    "指定的價格不存在": "指定的价格不存在",
    "請選擇支付狀態": "请选择支付状态",
    "指定的付款狀態不存在": "指定的付款状态不存在",
    "總教會不能進行後台報名": "总教会不能进行后台报名",
    "即將返回報名內容頁面": "即将返回报名内容页面",
    "活動報名已經額滿": "活动报名已经额满",
    "聯絡人電子郵件格式錯誤": "联络人电子邮件格式错误",
    "請完善表單內容": "请完善表单内容",
    "需要收費": "需要收费",
    "限制人數": "限制人数",
    "報名上限": "报名上限",
    "等待付款": "等待付款",
    "報名完成": "报名完成",
    "剩餘名額": "剩馀名额",
    "後台編輯": "后台编辑",
    "聯絡人電話號碼": "联络人电话号码",
    "報到二維碼": "报到二维码",
    "報名場次": "报名场次",
    "場次開始": "场次开始",
    "場次結束": "场次结束",
    "全部X場": "全部 <b>%s</b> 场",
    "報名來源": "报名来源",
    "請輸入聯絡人電話號碼": "请输入联络人电话号码",
    "請選擇報名來源": "请选择报名来源",
    "請選擇已付款": "请选择已付款",
    "即將更新報名內容": "即将更新报名内容",
    "App": "App",
    "外部": "外部",
    "後台": "后台",
    "即將手動標記付款請確認後執行": "<span class=\"cgRed\">即将手动标记付款, 请确认后执行</span>",
    "請注意這個活動已經停用": "请注意, 这个活动已经停用",
    "請注意總教會登入無法使用後台報名": "请注意, 总教会登入无法使用后台报名",
    "請注意這個活動報名已經額滿": "请注意, 这个活动报名已经额满",
    "請注意這個活動已經有X名會友已付費報名部分欄位無法修改請注意": "请注意, 这个活动已经有 <b class=\"ft-15\">%s</b> 名会友已付费报名, 部分栏位<b>无法修改</b>, 请注意",
    "活動已經開始報名截止": "活动已经开始, 报名截止",
    "下載二維碼": "下载二维码",
    "報到工具": "报到工具",
    "顯示二維碼": "显示二维码",
    "複製報名網址": "复製报名网址",
    "報名資訊": "报名资讯",
    "報名網址": "报名网址",
    "即將更新活動內容": "即将更新活动内容",
    "密碼": "密码",
    "即將更新個人內容": "即将更新个人内容",
    "更新密碼成功後將自動登出請您使用新密碼登入請確認後執行": "<b class=\"text-danger\">更新密码成功后将自动登出<br/>请您使用新密码登入, 请确认后执行</b>",
    "請輸入電話": "请输入电话",
    "新增新朋友": "新增新朋友",
    "自行註冊": "自行注册",
    "關係": "关係",
    "請確認將指定的會友標記為待轉入": "请确认将指定的会友<span class=\"text-danger\">标记为待转入</span>",
    "請確認將指定的會友標記為不轉入": "请确认将指定的会友<span class=\"text-danger\">标记为不转入</span>",
    "請確認將指定的會友轉入至牧養會友": "请确认将指定的会友<span class=\"text-danger\">转入至牧养会友</span>",
    "請注意這名新朋友已經標記為不轉入": "请注意, 这名新朋友已经标记为不转入",
    "未選擇所在地區": "未选择所在地区",
    "未選擇所在城市": "未选择所在城市",
    "更多選項": "更多选项",
    "收起選項": "收起选项",
    "為該族群的託管人員": "为该族群的託管人员",
    "未跟進": "未跟进",
    "已標註會友": "已标注会友",
    "加註": "加注",
    "連結": "连结",
    "所在區域": "所在区域",
    "請選擇需要篩選的族群": "请选择需要筛选的族群",
    "請選擇稱謂": "请选择称谓",
    "請選擇職業": "请选择职业",
    "請選擇教育程度": "请选择教育程度",
    "請選擇五重執事": "请选择五重执事",
    "請選擇婚姻狀況": "请选择婚姻状况",
    "即將對此會友進行加註": "即将对此会友进行加注",
    "即將對此會友移除加註": "即将对此会友移除加注",
    "即將刪除會友請確認後執行": "<span class=\"cgRed\">即将删除会友, 请确认后执行</span>",
    "聚會": "聚会",
    "請選擇聚會": "请选择聚会",
    "相關歷程": "相关历程",
    "課程": "课程",
    "英文名字/暱稱": "英文名字/暱称",
    "手機": "手机",
    "其他電話": "其他电话",
    "居住地址": "居住地址",
    "最高學校名稱": "最高学校名称",
    "配偶名字": "配偶名字",
    "配偶聯絡方式": "配偶联络方式",
    "監護人名字": "监护人名字",
    "監護人關係": "监护人关係",
    "監護人聯絡方式": "监护人联络方式",
    "進入教會日期": "进入教会日期",
    "離開教會日期": "离开教会日期",
    "離開教會原因": "离开教会原因",
    "是否受洗": "是否受洗",
    "受洗日期": "受洗日期",
    "受洗教會": "受洗教会",
    "請輸入英文名字/暱稱": "请输入英文名字/暱称",
    "請選擇生日": "请选择生日",
    "請輸入手機": "请输入手机",
    "請輸入其他電話": "请输入其他电话",
    "請輸入居住地址": "请输入居住地址",
    "請輸入最高學校名稱": "请输入最高学校名称",
    "請輸入配偶名字": "请输入配偶名字",
    "請輸入配偶聯絡方式": "请输入配偶联络方式",
    "請輸入監護人名字": "请输入监护人名字",
    "請輸入監護人關係": "请输入监护人关係",
    "請輸入監護人聯絡方式": "请输入监护人联络方式",
    "請選擇進入教會日期": "请选择进入教会日期",
    "請選擇離開教會日期": "请选择离开教会日期",
    "請輸入離開教會原因": "请输入离开教会原因",
    "請填寫是否受洗": "请填写是否受洗",
    "請選擇受洗日期": "请选择受洗日期",
    "請輸入受洗教會": "请输入受洗教会",
    "批次委派": "批次委派",
    "會友匯入": "会友汇入",
    "會友匯出": "会友汇出",
    "全部刪除": "全部删除",
    "上一步": "上一步",
    "請先選擇族群": "请先选择族群",
    "下一步": "下一步",
    "請先選擇會友": "请先选择会友",
    "確認委派": "确认委派",
    "重新委派": "重新委派",
    "匯入會友檔案範例_完整": "汇入会友档案范例_完整",
    "下載範例": "下载范例",
    "請先匯入會友資訊": "请先汇入会友资讯",
    "重新匯入": "重新汇入",
    "執行匯入": "执行汇入",
    "執行匯出": "执行汇出",
    "執行刪除": "执行删除",
    "類別": "类别",
    "請選擇類別": "请选择类别",
    "即將進行批次委派": "即将进行批次委派",
    "即將進行重新匯入": "即将进行重新汇入",
    "即將進行會友匯入": "即将进行会友汇入",
    "選項": "选项",
    "請先建立聚會分類": "请先建立聚会分类",
    "簽到工具顯示應到會友": "签到工具显示应到会友",
    "請選擇簽到工具顯示應到會友": "请选择签到工具显示应到会友",
    "允許會友自行簽到": "允许会友自行签到",
    "請選擇允許會友自行簽到": "请选择允许会友自行签到",
    "會友可自行於牧養對話中簽到": "会友可自行于牧养对话中签到",
    "需要透過簽到工具或小組長出示掃描會友二維碼進行簽到": "需要透过签到工具或小组长出示扫描会友二维码进行签到",
    "目前聚會處於僅讀取狀態無法更新": "目前聚会处于仅读取状态无法更新",
    "目前聚會處於停用狀態": "目前聚会处于停用状态",
    "請選擇自行簽到": "请选择自行签到",
    "請完善選項的參數設定": "请完善选项的参数设定",
    "未開始": "未开始",
    "進行中": "进行中",
    "已結束": "已结束",
    "無聚會": "无聚会",
    "群族名稱": "群族名称",
    "請輸入群族名稱": "请输入群族名称",
    "等待生成": "等待生成",
    "已生成": "已生成",
    "生成逾期": "生成逾期",
    "預計生成時間": "预计生成时间",
    "實際生成時間": "实际生成时间",
    "推送時間": "推送时间",
    "寄送郵件時間": "寄送邮件时间",
    "請先選擇所屬教會": "请先选择所属教会",
    "即將啟用聚會": "即将启用聚会",
    "即將停用聚會": "即将停用聚会",
    "即將刪除聚會請確認後執行": "<span class=\"cgRed\">即将删除聚会, 请确认后执行</span>",
    "新增類別": "新增类别",
    "即將新增類別": "即将新增类别",
    "即將更新類別內容": "即将更新类别内容",
    "新增聚會": "新增聚会",
    "需要透過簽到工具或小組長出示/掃描會友二維碼進行簽到": "需要透过签到工具或小组长出示/扫描会友二维码进行签到",
    "首次": "首次",
    "請選擇是否允許會友自行簽到": "请选择是否允许会友自行签到",
    "請選擇簽到工具是否顯示應到會友": "请选择签到工具是否显示应到会友",
    "即將新增聚會": "即将新增聚会",
    "請注意這個聚會已經停用": "请注意, 这个聚会已经停用",
    "下載報到介面二維碼": "下载报到介面二维码",
    "前往報到介面": "前往报到介面",
    "顯示報到介面二維碼": "显示报到介面二维码",
    "複製報到介面網址": "复製报到介面网址",
    "即將更新聚會內容": "即将更新聚会内容",
    "聚會標題": "聚会标题",
    "聚會尚未開始": "聚会尚未开始",
    "聚會正在進行": "聚会正在进行",
    "聚會已經結束": "聚会已经结束",
    "重製點名單": "重製点名单",
    "聚會已經結束無法重製點名單": "聚会已经结束, 无法重製点名单",
    "X_報到介面二維碼": "%s_报到介面二维码",
    "APP專用報到二維碼": "APP专用报到二维码",
    "點擊下載": "点击下载",
    "若您發現點名單成員不正確可進行點名單重製請確認後執行": "若您发现点名单成员不正确<br />可进行点名单重製, 请确认后执行",
    "請參考提醒設定值": "请参考提醒设定值",
    "不發送": "不发送",
    "等待發送": "等待发送",
    "正在準備發送": "正在准备发送",
    "發送完成": "发送完成",
    "預定生成時間": "预定生成时间",
    "預設提前生成": "预设提前生成",
    "推送狀態": "推送状态",
    "推送完成時間": "推送完成时间",
    "寄送郵件狀態": "寄送邮件状态",
    "寄送郵件完成時間": "寄送邮件完成时间",
    "請選擇預定生成時間": "请选择预定生成时间",
    "展開全部統計": "展开全部统计",
    "收起全部統計": "收起全部统计",
    "新增族群": "新增族群",
    "新增同階族群": "新增同阶族群",
    "新增子族群": "新增子族群",
    "回上一階": "回上一阶",
    "組織圖": "组织图",
    "無子族群供顯示組織圖": "无子族群供显示组织图",
    "無下一階": "无下一阶",
    "下一階": "下一阶",
    "該族群缺少託管人員請盡快編輯設定": "该族群缺少託管人员, 请尽快编辑设定",
    "查看聚會": "查看聚会",
    "已設定聚會無法刪除請先刪除已設定聚會": "已设定聚会, 无法删除<br/>请先删除已设定聚会",
    "已設定有子族群無法刪除請先刪除所有子族群": "已设定有子族群, 无法删除<br/>请先删除所有子族群",
    "託管人員-合計": "託管人员 - 合计",
    "族群成員": "族群成员",
    "族群成員-合計": "族群成员 - 合计",
    "即將重設該教會牧養相關功能包括牧養對話群組與聚會等相關功能重設將無法恢復請確認後執行": "<span class=\"cgRed\">即将重设该教会牧养相关功能<br/>包括牧养对话群组与聚会等相关功能<br/>重设将无法恢復, 请确认后执行</span>",
    "即將刪除族群刪除後牧養對話群組將會解散並無法恢復請確認後執行": "<span class=\"cgRed\">即将删除族群, 删除后牧养对话群组将会解散<br/>并无法恢復, 请确认后执行</span>",
    "合計次數": "合计次数",
    "暫無資料": "暂无资料",
    "列表對象為群組第一層全教會各佔比點選群組名稱可查閱下一級群組該牧區計算參與服事人數/總人數=全教會服事比例": "列表对象为群组第一层全教会各佔比，点选群组名称可查阅下一级群组<br/><span class=\"text-danger\">该牧区计算: 参与服事人数 / 总人数 = 全教会服事比例</span>",
    "統計服事對象": "统计服事对象",
    "溫度服事對象": "温度服事对象",
    "30天以上未參加": "30天以上未参加",
    "60天以上未參加": "60天以上未参加",
    "90天以上未參加": "90天以上未参加",
    "合計 <b class=\"text-success ft-15\">%s</b> 位": "合计 <b class=\"text-success ft-15\">%s</b> 位",
    "共X位": "共 <b class=\"text-%s ft-15\">%s</b> 位",
    "離開服事對象": "离开服事对象",
    "合計 <b class=\"text-danger ft-15\">%s</b> 位": "合计 <b class=\"text-danger ft-15\">%s</b> 位",
    "新增服事人數 <span class=\"ft-14\">(月)</span>": "新增服事人数 <span class=\"ft-14\">(月)</span>",
    "新增服事人數 <span class=\"ft-14\">(週)</span>": "新增服事人数 <span class=\"ft-14\">(週)</span>",
    "合計 <b class=\"text-info ft-15\">%s</b> 位": "合计 <b class=\"text-info ft-15\">%s</b> 位",
    "總人數": "总人数",
    "參與服事人數": "参与服事人数",
    "未參與服事人數": "未参与服事人数",
    "參與服事比例%": "参与服事比例 <span class=\"ft-12\">(%)</span>",
    "前月參與服事比例%": "前月参与服事比例 <span class=\"ft-12\">(%)</span>",
    "新增服事人數 <span class=\"ft-12\">(月)</span>": "新增服事人数 <span class=\"ft-12\">(月)</span>",
    "新增服事人數 <span class=\"ft-12\">(週)</span>": "新增服事人数 <span class=\"ft-12\">(週)</span>",
    "離開服事人數": "离开服事人数",
    "性別": "性别",
    "佔比": "佔比",
    "總和": "总和",
    "弟兄": "弟兄",
    "姐妹": "姐妹",
    "未登記": "未登记",
    "年齡": "年龄",
    "0-9歲": "0-9岁",
    "10-19歲": "10-19岁",
    "20-29歲": "20-29岁",
    "30-39歲": "30-39岁",
    "40-49歲": "40-49岁",
    "50-59歲": "50-59岁",
    "60-69歲": "60-69岁",
    "70-79歲": "70-79岁",
    "80-89歲": "80-89岁",
    "90-99歲": "90-99岁",
    "100-109歲": "100-109岁",
    "110-119歲": "110-119岁",
    "120-129歲": "120-129岁",
    "執事": "执事",
    "使徒": "使徒",
    "先知": "先知",
    "傳福音": "传福音",
    "牧師": "牧师",
    "教師": "教师",
    "程度": "程度",
    "小學": "小学",
    "中學": "中学",
    "專科": "专科",
    "高中": "高中",
    "高職/高商": "高职/高商",
    "大學": "大学",
    "碩士": "硕士",
    "博士": "博士",
    "行政經營": "行政经营",
    "業務行銷": "业务行销",
    "人事法務": "人事法务",
    "財會金融": "财会金融",
    "廣告美編": "广告美编",
    "客戶服務": "客户服务",
    "電腦硬體": "电脑硬体",
    "資訊軟體": "资讯软体",
    "品管製造": "品管製造",
    "技術服務": "技术服务",
    "營建職業": "营建职业",
    "傳播媒體": "传播媒体",
    "娛樂演藝": "娱乐演艺",
    "教育學術": "教育学术",
    "醫療美容": "医疗美容",
    "保全警衛": "保全警卫",
    "家事服務": "家事服务",
    "農林魚牧": "农林鱼牧",
    "慈善宗教": "慈善宗教",
    "交通及物流服務": "交通及物流服务",
    "餐飲旅遊運動": "餐饮旅游运动",
    "美容美髮": "美容美髮",
    "軍公教": "军公教",
    "家管": "家管",
    "兒童": "儿童",
    "待業": "待业",
    "學生": "学生",
    "狀況": "状况",
    "已婚": "已婚",
    "未婚": "未婚",
    "喪偶": "丧偶",
    "再婚": "再婚",
    "離婚": "离婚",
    "即將進行重建模擬請確認後執行": "<span class=\"cgRed\">即将进行重建模拟, 请确认后执行</span>",
    "即將進行模擬登入請確認後執行": "<span class=\"cgRed\">即将进行模拟登入, 请确认后执行</span>",
    "即將返回管理介面": "即将返回管理介面",
    "即將登出系統": "即将登出系统",
    "請確認登出": "请确认登出",
    "連線權杖逾時": "连线权杖逾时",
    "Oops🤕🤕請您重新登入系統": "Oops! 🤕🤕 请您重新登入系统",
    "未授權的存取": "未授权的存取",
    "Oops😳😳您可能沒有存取的權限": "Oops! 😳😳 您可能没有存取的权限",
    "頁面不存在": "页面不存在",
    "Oops😱😱您訪問的頁面不存在或暫時不可用": "Oops! 😱😱 您访问的页面不存在或暂时不可用",
    "這出了點小問題": "这出了点小问题",
    "Oops😵😵無法正確連結至伺服器": "Oops! 😵😵 无法正确连结至伺服器",
    "Oops🙁🙁您上傳的檔案容量超出限制": "Oops! 🙁🙁 您上传的档案容量超出限制",
    "Oops🥺🥺伺服器好像罷工了": "Oops! 🥺🥺 伺服器好像罢工了",
    "Oops😵‍💫😵‍💫連結到伺服器超出預期時間": "Oops! 😵‍💫😵‍💫 连结到伺服器超出预期时间",
    "上傳檔案發生錯誤": "上传档案发生错误",
    "單個檔案超過XX限制": "单个档案超过 <b class=\"ft-20 text-danger\">%s</b> %s限制",
    "檔案合計超過XX限制": "档案合计超过 <b class=\"ft-20 text-danger\">%s</b> %s限制",
    "產生預覽圖失敗": "产生预览图失败",
    "上傳檔案中包含不支援的圖片編碼": "上传档案中包含不支援的图片编码",
    "分享連結出現錯誤": "分享连结出现错误",
    "請確認您的分享連結是否正確": "请确认您的分享连结是否正确",
    "二級驗證失敗": "二级验证失败",
    "請確認您的登入密碼是否正確": "请确认您的登入密码是否正确",
    "Oops😲😲發生未知錯誤": "Oops! 😲😲 发生未知错误",
    "核准": "核准",
    "拒絕": "拒绝",
    "預覽": "预览",
    "插入": "插入",
    "返回": "返回",
    "選擇": "选择",
    "返回首頁": "返回首页",
    "回列表": "回列表",
    "重新登入": "重新登入",
    "登入": "登入",
    "找回密碼": "找回密码",
    "確認送出": "确认送出",
    "重設密碼": "重设密码",
    "登入中": "登入中",
    "登入成功請稍候": "登入成功...请稍候",
    "好": "好",
    "回到頂部": "回到顶部",
    "儲存": "储存",
    "變更": "变更",
    "查詢": "查询",
    "重新讀取": "重新读取",
    "取消": "取消",
    "送出": "送出",
    "完成": "完成",
    "重新整理": "重新整理",
    "取代": "取代",
    "前往": "前往",
    "執行教會編號": "执行教会编号",
    "執行教會名稱": "执行教会名称",
    "剛剛": "刚刚",
    "%s分鐘前": "%s分钟前",
    "%s小時前": "%s小时前",
    "X天前": "%s天前",
    "選擇年": "选择年",
    "選擇月": "选择月",
    "往前1年": "往前 1 年",
    "往前1個月": "往前 1 个月",
    "往前10年": "往前 10 年",
    "往後1年": "往后 1 年",
    "往後1個月": "往后 1 个月",
    "往後10年": "往后 10 年",
    "點擊使用滑桿模式": "点击使用滑杆模式",
    "增加1小時": "增加 1 小时",
    "增加X分鐘": "增加 %s 分钟",
    "減少1小時": "减少 1 小时",
    "減少X分鐘": "减少 %s 分钟",
    "小於最早時間限制": "小于最早时间限制",
    "最早時間限制為X請您重新選擇": "最早时间限制为 <b class=\"ft-20 text-danger\">%s</b><br />请您重新选择",
    "大於最晚時間限制": "大于最晚时间限制",
    "最晚時間限制為X請您重新選擇": "最晚时间限制为 <b class=\"ft-20 text-danger\">%s</b><br />请您重新选择",
    "牧養相關功能暫停使用": "牧养相关功能暂停使用",
    "該功能目前處於維護狀態暫時無法使用開放時間將另行通知造成您的不便請多見諒": "该功能目前处于维护状态暂时无法使用<br/>开放时间将另行通知, 造成您的不便请多见谅",
    "操作成功": "操作成功",
    "服務降級保護中": "服务降级保护中",
    "服務目前處於降級保護的狀態請稍後再試": "服务目前处于降级保护的状态, 请稍后再试",
    "服務流控管制中": "服务流控管制中",
    "服務目前處於流控管制的狀態請稍後再試": "服务目前处于流控管制的状态, 请稍后再试",
    "服務熱點限制中": "服务热点限制中",
    "服務目前處於熱點限制的狀態請稍後再試": "服务目前处于热点限制的状态, 请稍后再试",
    "系統規則不滿足要求": "系统规则不满足要求",
    "請稍後再試": "请稍后再试",
    "授權規則不通過": "授权规则不通过",
    "連線權杖逾時或不正確": "连线权杖逾时或不正确",
    "公司授權已經到期": "公司授权已经到期",
    "請向我們的銷售人員聯絡謝謝": "请向我们的销售人员联络, 谢谢",
    "無存取權限": "无存取权限",
    "Oops😵😵存取的服務存在異常": "Oops! 😵😵 存取的服务存在异常",
    "Oops😵😵連結到伺服器超出預期時間": "Oops! 😵😵 连结到伺服器超出预期时间",
    "Oops😵😵系統模組連接異常": "Oops! 😵😵 系统模组连接异常",
    "標記為": "标记为",
    "為必填欄位": "为必填栏位",
    "點擊停用": "点击停用",
    "點擊啟用": "点击启用",
    "無資料": "无资料",
    "更新": "更新",
    "設定的所有循環均已完成, 將不會再繼續生成相關單據與提醒": "设定的所有循环均已完成, 将不会再继续生成相关单据与提醒",
    "聚會週期建立後不可修改, 以免既有的點名紀錄對應到錯誤的場次。如需調整請建立新的聚會": "聚会周期建立后不可修改, 以免既有的点名纪录对应到错误的场次。如需调整请建立新的聚会",
    "已達選項上限": "已达选项上限",
    "自訂": "自订",
    "新增提醒": "新增提醒",
    "提前生成": "提前生成",
    "載入中": "载入中",
    "正在計算統計數據...": "正在计算统计数据...",
    "搜尋範圍: 名字/郵件/編號": "搜寻范围: 名字/邮件/编号",
    "可選擇 %s 位會友": "可选择 %s 位会友",
    "已選擇 %s 位會友": "已选择 %s 位会友",
    "異動項目將會清除, 請確認後執行": "异动项目将会清除, 请确认后执行",
    "提醒時間": "提醒时间",
    "分鐘前": "分钟前",
    "小時前": "小时前",
    "日前": "日前",
    "週前": "周前",
    "電子郵件清單": "电子邮件清单",
    "循環明細": "循环明细",
    "此服事為單次循環": "此服事为单次循环",
    "選擇成員": "选择成员",
    "會友": "会友",
    "無可選名單": "无可选名单",
    "尚未選擇名單": "尚未选择名单",
    "可選": "可选",
    "名會友": "名会友",
    "已選": "已选",
    "查無符合的名單": "查无符合的名单",
    "最多可選": "最多可选",
    "還可選": "还可选",
    "新增信箱": "新增邮箱",
    "請先於基本分頁設定開始與結束時間": "请先于基本分页设定开始与结束时间",
    "尚未選擇參與人員": "尚未选择参与人员",
    "請至少選擇一位參與人員後再儲存": "请至少选择一位参与人员后再储存",
    "提醒設定尚未完成": "提醒设定尚未完成",
    "尚未選擇提醒時間": "尚未选择提醒时间",
    "請至少勾選一項提醒時間": "请至少勾选一项提醒时间",
    "選擇 Email 通知時，請至少填寫一個有效的電子郵件": "选择 Email 通知时，请至少填写一个有效的电子邮件",
    "循環設定尚未完成": "循环设定尚未完成",
    "分": "分",
    "時": "时",
    "教會新增成功": "教会新增成功",
    "教會內容更新成功": "教会内容更新成功",
    "時區與機構設定": "时区与机构设定",
    "時區設定": "时区设定",
    "請點擊圖示產生隨機邀請碼": "请点击图示产生随机邀请码",
    "請點擊圖示自行輸入邀請碼": "请点击图示自行输入邀请码",
    "共計": "共计",
    "次閱讀": "次阅读",
    "篩選出": "筛选出",
    "筆公告": "笔公告",
    "尚未選擇收件人": "尚未选择收件人",
    "目前沒有任何推播": "目前没有任何推播",
    "請選擇排程": "请选择排程",
    "建立日期(起)": "建立日期(起)",
    "建立日期(迄)": "建立日期(迄)",
    "左上": "左上",
    "右上": "右上",
    "置中": "置中",
    "左下": "左下",
    "右下": "右下",
    "圖片處理中, 請稍候": "图片处理中, 请稍候",
    "已經編輯的內容將會重設, 請確認後執行": "已经编辑的内容将会重设, 请确认后执行",
    "新增文字": "新增文字",
    "刪除文字": "删除文字",
    "請先選擇文字": "请先选择文字",
    "背景顏色": "背景颜色",
    "請選擇背景顏色": "请选择背景颜色",
    "靠左": "靠左",
    "靠右": "靠右",
    "文字描邊": "文字描边",
    "描邊粗細": "描边粗细",
    "描邊顏色": "描边颜色",
    "請選擇描邊顏色": "请选择描边颜色",
    "文字陰影": "文字阴影",
    "陰影模糊": "阴影模糊",
    "陰影顏色": "阴影颜色",
    "請選擇陰影顏色": "请选择阴影颜色",
    "底色濃度": "底色浓度",
    "文字底色": "文字底色",
    "請選擇文字底色": "请选择文字底色",
    "旋轉翻轉": "旋转翻转",
    "縮放": "缩放",
    "濾鏡": "滤镜",
    "亮度": "亮度",
    "對比": "对比",
    "飽和度": "饱和度",
    "選擇下方工具開始編輯": "选择下方工具开始编辑",
    "自訂顏色": "自订颜色",
    "向左旋轉": "向左旋转",
    "向右旋轉": "向右旋转",
    "水平翻轉": "水平翻转",
    "垂直翻轉": "垂直翻转",
    "點畫布上的文字可以編輯它": "点画布上的文字可以编辑它",
    "顏色": "颜色",
    "描邊": "描边",
    "陰影": "阴影",
    "底色": "底色",
    "背景": "背景",
    "使用這張圖": "使用这张图",
    "復原": "复原",
    "重做": "重做",
    "上傳貼圖": "上传贴图",
    "貼圖": "贴图",
    "透明度": "透明度",
    "拖曳可以移動, 拉四個角可以縮放": "拖曳可以移动, 拉四个角可以缩放",
    "位置": "位置",
    "水平對齊": "水平对齐",
    "垂直對齊": "垂直对齐",
    "文字對齊": "文字对齐",
    "靠上": "靠上",
    "靠下": "靠下",
    "疊放順序": "叠放顺序",
    "上移一層": "上移一层",
    "下移一層": "下移一层",
    "拖曳時會自動吸附對齊; 方向鍵可微調, 按住 Shift 移動較快": "拖曳时会自动吸附对齐; 方向键可微调, 按住 Shift 移动较快",

    // ---- 文章管理（心靈捕手匯入 / 複製 / 共用） ----
    "文章複製成功": "文章复制成功",
    "僅能指定自行維護文章的教會": "仅能指定自行维护文章的教会",
    "即將匯入心靈捕手文章": "即将汇入心灵捕手文章",
    "文章新增成功": "文章新增成功",
    "封面圖來源讀取失敗，請自行上傳封面圖": "封面图来源读取失败，请自行上传封面图",
    "尚未完成必填欄位": "尚未完成必填栏位",

    // ---- 補齊：頁面已使用但先前未定義的中文 key（2026-08 全庫掃描）----
    "(依照預定推播時間降冪排序)": "(依照预定推播时间降幂排序)",
    "MP3 連結": "MP3 连结",
    "上架時間需早於活動開始時間": "上架时间需早于活动开始时间",
    "上架時間需早於直播開始時間": "上架时间需早于直播开始时间",
    "主要聯絡人": "主要联络人",
    "個人內容更新成功": "个人内容更新成功",
    "優惠": "优惠",
    "免費活動無法使用線上支付": "免费活动无法使用线上支付",
    "全體推播請選擇要排除的機構": "全体推播请选择要排除的机构",
    "公告停用成功": "公告停用成功",
    "公告刪除成功": "公告删除成功",
    "公告啟用成功": "公告启用成功",
    "共": "共",
    "分類停用成功": "分类停用成功",
    "分類刪除成功": "分类删除成功",
    "分類啟用成功": "分类启用成功",
    "刪除後將無法復原, 請確認後執行": "删除后将无法复原, 请确认后执行",
    "剩餘": "剩馀",
    "即將標示已付款": "即将标示已付款",
    "反饋內容更新成功": "反馈内容更新成功",
    "取消置頂成功": "取消置顶成功",
    "可選會友": "可选会友",
    "回應詞 - 代禱": "回应词 - 代祷",
    "回條封面圖": "回条封面图",
    "回條描述": "回条描述",
    "報名內容更新成功": "报名内容更新成功",
    "報名成功後寄送給報名者的回條（封面圖與說明）": "报名成功后寄送给报名者的回条（封面图与说明）",
    "場": "场",
    "場次變更成功": "场次变更成功",
    "奉獻日期(起)": "奉献日期(起)",
    "奉獻日期(迄)": "奉献日期(迄)",
    "如果不需要變更密碼, 不用填寫": "如果不需要变更密码, 不用填写",
    "尚未選擇排除機構": "尚未选择排除机构",
    "尚無留言": "尚无留言",
    "尚無資料": "尚无资料",
    "已整合": "已整合",
    "已為您轉交愛無界團隊": "已为您转交爱无界团队",
    "已讀": "已读",
    "已達優惠數量上限": "已达优惠数量上限",
    "已達電子郵件數量上限": "已达电子邮件数量上限",
    "已選會友": "已选会友",
    "建立時間(起)": "建立时间(起)",
    "建立時間(迄)": "建立时间(迄)",
    "影音連結": "影音连结",
    "待付款": "待付款",
    "待送出": "待送出",
    "拖拉排序": "拖拉排序",
    "拖拉調整排序": "拖拉调整排序",
    "指定推播請至少選擇一位收件人後再儲存": "指定推播请至少选择一位收件人后再储存",
    "指定推播需選擇收件人後才能儲存": "指定推播需选择收件人后才能储存",
    "挑選名單": "挑选名单",
    "推播刪除成功": "推播删除成功",
    "提醒方式": "提醒方式",
    "搜尋名稱 / 信箱": "搜寻名称 / 邮箱",
    "收費": "收费",
    "教學停用成功": "教学停用成功",
    "教學刪除成功": "教学删除成功",
    "教學啟用成功": "教学启用成功",
    "教會(機構)名稱": "教会(机构)名称",
    "教會(機構)所在城市": "教会(机构)所在城市",
    "教會名稱": "教会名称",
    "教會編號": "教会编号",
    "整合文章的內文圖片，可上傳多張並排序": "整合文章的内文图片，可上传多张并排序",
    "文章停用成功": "文章停用成功",
    "文章刪除成功": "文章删除成功",
    "文章啟用成功": "文章启用成功",
    "文章留言刪除成功": "文章留言删除成功",
    "文章置頂成功": "文章置顶成功",
    "新增優惠": "新增优惠",
    "暫時沒有可排序的資料": "暂时没有可排序的资料",
    "暫無填寫資料": "暂无填写资料",
    "最多報名人數": "最多报名人数",
    "最少報名人數": "最少报名人数",
    "未命名場次": "未命名场次",
    "未命名欄位": "未命名栏位",
    "未整合": "未整合",
    "未設定優惠": "未设定优惠",
    "查無資料": "查无资料",
    "標示已付款成功": "标示已付款成功",
    "標籤 - 代禱": "标籤 - 代祷",
    "標籤 - 大廳": "标籤 - 大厅",
    "標籤 - 關於": "标籤 - 关于",
    "欄位種類": "栏位种类",
    "次要聯絡人": "次要联络人",
    "歡迎詞 - 代禱": "欢迎词 - 代祷",
    "歡迎詞 - 大廳": "欢迎词 - 大厅",
    "此推播已完成，僅供查看無法修改": "此推播已完成，仅供查看无法修改",
    "此教會尚未開通線上支付": "此教会尚未开通线上支付",
    "此活動已有報名，既有欄位已鎖定不可修改；仍可新增欄位，但新增的欄位不可設為必填。": "此活动已有报名，既有栏位已锁定不可修改；仍可新增栏位，但新增的栏位不可设为必填。",
    "活動停用成功": "活动停用成功",
    "活動刪除成功": "活动删除成功",
    "活動啟用成功": "活动启用成功",
    "活動已有報名，新增的欄位不可設為必填": "活动已有报名，新增的栏位不可设为必填",
    "清除邀請碼": "清除邀请码",
    "留言數量重算完成": "留言数量重算完成",
    "登入成功...請稍候": "登入成功...请稍候",
    "目前推播正在進行中無法修改": "目前推播正在进行中无法修改",
    "直播停用成功": "直播停用成功",
    "直播刪除成功": "直播删除成功",
    "直播啟用成功": "直播启用成功",
    "確定要停用此服事嗎？": "确定要停用此服事吗？",
    "確定要刪除此推播嗎？": "确定要删除此推播吗？",
    "確定要刪除此服事嗎？": "确定要删除此服事吗？",
    "確定要啟用此服事嗎？": "确定要启用此服事吗？",
    "確定要重設嗎？": "确定要重设吗？",
    "社群分享（LINE／Facebook 等）預覽時顯示的文字": "社群分享（LINE／Facebook 等）预览时显示的文字",
    "第": "第",
    "筆": "笔",
    "系統": "系统",
    "結束日期": "结束日期",
    "結束時間(起)": "结束时间(起)",
    "結束時間(迄)": "结束时间(迄)",
    "編輯收件人名單": "编辑收件人名单",
    "總報名": "总报名",
    "自行輸入": "自行输入",
    "若只有一個場次，此頁籤不用填寫": "若只有一个场次，此页籤不用填写",
    "藍新金流Hash IV": "蓝新金流Hash IV",
    "藍新金流Hash KEY": "蓝新金流Hash KEY",
    "藍新金流Merchant ID": "蓝新金流Merchant ID",
    "請注意, 這個分類已經停用": "请注意, 这个分类已经停用",
    "請注意, 這個教學已經停用": "请注意, 这个教学已经停用",
    "請注意, 這個直播已經停用": "请注意, 这个直播已经停用",
    "請至少填寫一組電子郵件": "请至少填写一组电子邮件",
    "請至少選擇一位收件人": "请至少选择一位收件人",
    "請至少選擇一位會友進行推播": "请至少选择一位会友进行推播",
    "請至少選擇一種提醒方式": "请至少选择一种提醒方式",
    "請輸入 Google 雲端 MP3 連結": "请输入 Google 云端 MP3 连结",
    "請輸入 MP3 連結": "请输入 MP3 连结",
    "請輸入 YouTube 連結": "请输入 YouTube 连结",
    "請輸入回應詞(代禱)": "请输入回应词(代祷)",
    "請輸入影音連結": "请输入影音连结",
    "請輸入教會(機構)名稱": "请输入教会(机构)名称",
    "請輸入教會(機構)所在城市": "请输入教会(机构)所在城市",
    "請輸入標籤(代禱)": "请输入标籤(代祷)",
    "請輸入標籤(大廳)": "请输入标籤(大厅)",
    "請輸入標籤(關於)": "请输入标籤(关于)",
    "請輸入歡迎詞(代禱)": "请输入欢迎词(代祷)",
    "請輸入歡迎詞(大廳)": "请输入欢迎词(大厅)",
    "請輸入活動內容": "请输入活动内容",
    "請輸入藍新金流Hash IV": "请输入蓝新金流Hash IV",
    "請輸入藍新金流Hash KEY": "请输入蓝新金流Hash KEY",
    "請輸入藍新金流Merchant ID": "请输入蓝新金流Merchant ID",
    "請輸入費用": "请输入费用",
    "請選擇": "请选择",
    "請選擇來源": "请选择来源",
    "請選擇場次": "请选择场次",
    "請選擇建立日期(起)": "请选择建立日期(起)",
    "請選擇建立日期(迄)": "请选择建立日期(迄)",
    "請選擇收件人": "请选择收件人",
    "請選擇等級": "请选择等级",
    "請選擇結束時間(迄)": "请选择结束时间(迄)",
    "請選擇讀取狀態": "请选择读取状态",
    "請選擇開啟狀態": "请选择开启状态",
    "請選擇贊助日期(起)": "请选择赞助日期(起)",
    "請選擇贊助日期(迄)": "请选择赞助日期(迄)",
    "請選擇開始時間(起)": "请选择开始时间(起)",
    "贊助日期(起)": "赞助日期(起)",
    "贊助日期(迄)": "赞助日期(迄)",
    "起始日期": "起始日期",
    "開始日期": "开始日期",
    "開始時間(起)": "开始时间(起)",
    "開始時間(迄)": "开始时间(迄)",
    "附加": "附加",
    "隨機產生": "随机产生",
    "需要早於直播開始時間": "需要早于直播开始时间",
    "需透過簽到工具或小組長掃描二維碼簽到": "需透过签到工具或小组长扫描二维码签到",
    "頁": "页",
    "預設發送": "预设发送",
    "點擊更換驗證碼": "点击更换验证码",
    "啟動圖排程": "启动图排程",

    // ===== APP首頁（第三個 Portal，目前只開放 org=4）=====
    "URL": "URL",
    "序號": "序号",
    "YouTube 影片與 MP3 音檔": "YouTube 影片与 MP3 音档",
    "代禱需求": "代祷需求",
    "儲存中...": "储存中...",
    "儲存設定": "储存设定",
    "分類新增成功": "分类新增成功",
    "分類更新成功": "分类更新成功",
    "各系列底下的訊息內容": "各系列底下的讯息内容",
    "團隊管理": "团队管理",
    "團隊類型": "团队类型",
    "封面、聚會時間、社群連結與地圖": "封面、聚会时间、社群连结与地图",
    "封面圖片": "封面图片",
    "封面影片": "封面影片",
    "封面設計": "封面设计",
    "封面類型": "封面类型",
    "小組": "小组",
    "建議上傳 16:9 比例的圖片": "建议上传 16:9 比例的图片",
    "建議上傳 16:9 比例的圖片，用於展示在首頁或其他頁面的頂部": "建议上传 16:9 比例的图片，用于展示在首页或其他页面的顶部",
    "建議上傳 16:9 比例的圖片，用於接受耶穌的頁面顯示": "建议上传 16:9 比例的图片，用于接受耶稣的页面显示",
    "建議上傳 1:1 正方形的圖片": "建议上传 1:1 正方形的图片",
    "建議上傳 1:1 正方形的圖片，前台會裁成圓形": "建议上传 1:1 正方形的图片，前台会裁成圆形",
    "建議使用 25:10 比例": "建议使用 25:10 比例",
    "影片": "影片",
    "影片或 mp3 網址": "影片或 mp3 网址",
    "成員刪除成功": "成员删除成功",
    "成員新增成功": "成员新增成功",
    "成員更新成功": "成员更新成功",
    "所屬分類": "所属分类",
    "接受耶穌圖片": "接受耶稣图片",
    "接受耶穌登錄": "接受耶稣登录",
    "提交時間": "提交时间",
    "搜尋姓名、電話或信箱...": "搜寻姓名、电话或信箱...",
    "搜尋姓名或職稱": "搜寻姓名或职称",
    "搜尋標題、副標題或內容": "搜寻标题、副标题或内容",
    "搜尋標題、描述或內容": "搜寻标题、描述或内容",
    "搜尋標題、描述或連結": "搜寻标题、描述或连结",
    "搜尋標題或描述": "搜寻标题或描述",
    "支援 YouTube、Vimeo 等影片連結或 mp3 等音訊檔連結": "支援 YouTube、Vimeo 等影片连结或 mp3 等音讯档连结",
    "敬拜刪除成功": "敬拜删除成功",
    "敬拜新增成功": "敬拜新增成功",
    "敬拜更新成功": "敬拜更新成功",
    "敬拜管理": "敬拜管理",
    "新增成員": "新增成员",
    "新增敬拜": "新增敬拜",
    "新增訊息": "新增讯息",
    "新增關鍵字": "新增关键字",
    "方便聯繫時間": "方便联系时间",
    "APP首頁": "APP首页",
    "標記為已處理": "标记为已处理",
    "標記為無效": "标记为无效",
    "決志留言": "决志留言",
    "決志表單的留言與處理狀態": "决志表单的留言与处理状态",
    "活動回顧": "活动回顾",
    "活動新增成功": "活动新增成功",
    "活動更新成功": "活动更新成功",
    "活動照片與連結": "活动照片与连结",
    "無": "无",
    "照片": "照片",
    "牧師、長老與傳道團隊成員": "牧师、长老与传道团队成员",
    "狀態已更新": "状态已更新",
    "目前有": "目前有",
    "確定要刪除這位成員嗎？": "确定要删除这位成员吗？",
    "確定要刪除這個分類嗎？": "确定要删除这个分类吗？",
    "確定要刪除這個活動嗎？": "确定要删除这个活动吗？",
    "確定要刪除這個關鍵字嗎？": "确定要删除这个关键字吗？",
    "確定要刪除這則訊息嗎？": "确定要删除这则讯息吗？",
    "確定要刪除這首敬拜嗎？": "确定要删除这首敬拜吗？",
    "確定要標記為已處理嗎？": "确定要标记为已处理吗？",
    "確定要標記為無效嗎？": "确定要标记为无效吗？",
    "確認": "确认",
    "社群媒體連結": "社群媒体连结",
    "筆未處理的決志留言": "笔未处理的决志留言",
    "簡介": "简介",
    "簡短描述": "简短描述",
    "精選分類": "精选分类",
    "精選訊息": "精选讯息",
    "精選訊息的系列分類": "精选讯息的系列分类",
    "網址格式不正確": "网址格式不正确",
    "編輯分類": "编辑分类",
    "編輯成員": "编辑成员",
    "編輯敬拜": "编辑敬拜",
    "編輯活動": "编辑活动",
    "編輯訊息": "编辑讯息",
    "編輯關鍵字": "编辑关键字",
    "聯絡資訊": "联络资讯",
    "聯繫方式": "联系方式",
    "職稱": "职称",
    "至": "至",
    "訊息刪除成功": "讯息删除成功",
    "訊息新增成功": "讯息新增成功",
    "訊息更新成功": "讯息更新成功",
    "詳細內容": "详细内容",
    "請輸入 Google Map URL": "请输入 Google Map URL",
    "請輸入 MP3 網址": "请输入 MP3 网址",
    "請輸入 YouTube 網址": "请输入 YouTube 网址",
    "請輸入副標題": "请输入副标题",
    "請輸入影片網址（YouTube、Vimeo等）": "请输入影片网址（YouTube、Vimeo等）",
    "請輸入影片網址，支援 YouTube、Vimeo 等影片平台的連結": "请输入影片网址，支援 YouTube、Vimeo 等影片平台的连结",
    "請輸入成員簡介...": "请输入成员简介...",
    "請輸入排序號碼": "请输入排序号码",
    "請輸入活動標題": "请输入活动标题",
    "請輸入活動連結": "请输入活动连结",
    "請輸入簡短描述": "请输入简短描述",
    "請輸入網址": "请输入网址",
    "請輸入聚會時間": "请输入聚会时间",
    "請輸入職稱": "请输入职称",
    "請選擇團隊類型": "请选择团队类型",
    "請選擇所屬分類": "请选择所属分类",
    "資訊設定": "资讯设定",
    "資訊設定儲存成功": "资讯设定储存成功",
    "這裡維護的是 App 首頁與官網的內容，存檔後即時生效": "这里维护的是 App 首页与官网的内容，存档后即时生效",
    "關於我們": "关于我们",
    "關鍵字刪除成功": "关键字删除成功",
    "關鍵字新增成功": "关键字新增成功",
    "關鍵字更新成功": "关键字更新成功",
    "關鍵字管理": "关键字管理",
    "類型為 YouTube 時，網址必須是 youtube.com 或 youtu.be": "类型为 YouTube 时，网址必须是 youtube.com 或 youtu.be",
    "首頁的熱門搜尋關鍵字": "首页的热门搜寻关键字",
    "唯讀：您沒有編輯此活動的權限，僅能檢視內容": "只读：您没有编辑此活动的权限，仅能查看内容",
    "唯讀：您沒有新增活動的權限，僅能檢視內容": "只读：您没有新增活动的权限，仅能查看内容",
    "唯讀：您沒有更新報名內容的權限，僅能檢視內容": "只读：您没有更新报名内容的权限，仅能查看内容",
    "唯讀：您沒有後台報名的權限，僅能檢視表單": "只读：您没有后台报名的权限，仅能查看表单",
    "報到名單": "报到名单",
    "已報到": "已报到",
    "應到": "应到",
    "報到狀態": "报到状态",
    "報到時間": "报到时间",
    "報到人員": "报到人员",
    "後台標記": "后台标记",
    "標示已報到": "标示已报到",
    "取消報到": "取消报到",
    "即將標示已報到": "即将标示已报到",
    "即將取消報到": "即将取消报到",
    "標示已報到成功": "标示已报到成功",
    "取消報到成功": "取消报到成功",
    "請輸入姓名或電子郵件": "请输入姓名或电子邮件",
    "請選擇報到狀態": "请选择报到状态",
    "出席": "出席",
    "已自評": "已自评",
    "已留言": "已留言",
    "請選擇聚會排程": "请选择聚会排程",
    "Email": "Email",
    "簽到時間": "签到时间",
    "簽到方式": "签到方式",
    "Web 報到介面": "Web 报到界面",
    "請輸入姓名/Email/手機": "请输入姓名/Email/手机",
    "聚會類型": "聚会类型",
    "請選擇聚會類型": "请选择聚会类型",
    "聚會類型建立後不可修改": "聚会类型建立后不可修改",
    "掃描手可使用 App「實用工具 › 聚會掃描手」掃描會友行動條碼簽到，時間為排程開始前後 4 小時": "扫描手可使用 App「实用工具 › 聚会扫描手」扫描会友行动条码签到，时间为排程开始前后 4 小时",
    "已選擇掃描手": "已选择扫描手",
    "尚未選擇掃描手": "尚未选择扫描手",
    "新增掃描手": "新增扫描手",
    "已選擇": "已选择",
    "載入更多": "加载更多",
    // 教會管理 - 頻道管理
    "頻道管理": "频道管理",
    "頻道名稱": "频道名称",
    "留空則沿用教會名稱": "留空则沿用教会名称",
    "頻道名稱最多100個字": "频道名称最多100个字",
    "即將更新頻道設定": "即将更新频道设定",
    "此頁籤獨立儲存，頻道名稱與管理員會同步到 App 聊天的教會推播頻道": "此页签独立储存，频道名称与管理员会同步到 App 聊天的教会推播频道",
    "頻道管理員需為本教會的 App 會友，可在 App 聊天中管理教會推播頻道": "频道管理员需为本教会的 App 会友，可在 App 聊天中管理教会推播频道",
    "已選擇頻道管理員": "已选择频道管理员",
    "尚未選擇頻道管理員": "尚未选择频道管理员",
    "新增頻道管理員": "新增频道管理员",
    // App 錯誤追蹤
    "App 錯誤追蹤": "App 错误追踪",
    "近14天事件數": "近14天事件数",
    "事件數": "事件数",
    "復發": "复发",
    "錯誤": "错误",
    "區間次數": "区间次数",
    "總次數": "总次数",
    "最後版本": "最后版本",
    "首次出現": "首次出现",
    "最後出現": "最后出现",
    "平台": "平台",
    "版本": "版本",
    "錯誤類別 / 訊息": "错误类别 / 讯息",
    "發生日期(起)": "发生日期(起)",
    "發生日期(迄)": "发生日期(迄)",
    "請選擇發生日期(起)": "请选择发生日期(起)",
    "請選擇發生日期(迄)": "请选择发生日期(迄)",
    "標記已解決": "标记已解决",
    "標記為已解決": "标记为已解决",
    "之後若收到更新版本（build 大於下方填寫值）的事件，會自動重新開啟並標記為復發。": "之后若收到更新版本（build 大于下方填写值）的事件，会自动重新开启并标记为复发。",
    "忽略": "忽略",
    "忽略此錯誤": "忽略此错误",
    "忽略後新事件只會計數，不會再重新開啟。": "忽略后新事件只会计数，不会再重新开启。",
    "重新開啟": "重新开启",
    "重新開啟此錯誤": "重新开启此错误",
    "狀態將改回未解決。": "状态将改回未解决。",
    "解決於": "解决于",
    "解決於 Build": "解决于 Build",
    "解決於版本": "解决于版本",
    "選填": "选填",
    "Build 必須是正整數": "Build 必须是正整数",
    "未處理": "未处理",
    "影響裝置數": "影响装置数",
    "影響會友數": "影响会友数",
    "依近90天事件計算": "依近90天事件计算",
    "每日事件數": "每日事件数",
    "天": "天",
    "分布": "分布",
    "事件內容": "事件内容",
    "此錯誤沒有可檢視的事件明細（事件只保留 90 天，或因取樣未存明細）": "此错误没有可检视的事件明细（事件只保留 90 天，或因取样未存明细）",
    "訊息": "讯息",
    "堆疊": "堆叠",
    "系統版本": "系统版本",
    "語系": "语系",
    "App 版本": "App 版本",
    "Flavor": "Flavor",
    "環境": "环境",
    "嚴重度": "严重度",
    "已處理": "已处理",
    "發生畫面": "发生画面",
    "安裝識別碼": "安装识别码",
    "IP": "IP",
    "事件列表": "事件列表",
    "發生時間": "发生时间",
    "匿名": "匿名",
}
